import {LABOR_ALLOCATION_MODE} from "../../../hmodules/job-titles/constants/job-titles.constants.js";

(function (app) {

	var scheduleDataServiceV2;
	var scheduleDifferentialPayService;
	var tsUsersService;
	var MinorSchedulingService;
	var WorkRestrictionsService;
	var BreaksManagementService;
	var WorkVisasService;
	var JustCauseService;
	var teamScheduleService;
    var shiftTemplateUtils;
    var _scheduleDateUtilsService;
    let _jobTitlesDataService;
    let reportingTimeWarningsFactory;
	var SECOND = 1;
	// 1000 MILLISECOND every SECOND
	var MILLISECOND = 1000;
	// 60 SECONDS every MINUTE
	var MINUTE = 60 * SECOND;
	// 3600 SECONDS every HOUR
	var HOUR = 60 * MINUTE;
	// 24 * 3600 every DAY
    var DAY = 24 * HOUR;
    // Weeks per year are 52
    var WEEKS_PER_YEAR = 52;

    const SPREAD_OF_HOURS_MODES_MAP = {
        BUSINESS_DAY: 'BUSINESS_DAY',
        CALENDAR_DAY: 'CALENDAR_DAY',
    }

    var ScheduleCostsServiceV2 = function () {
        var self = this;
        var _emitter = JarEventEmitter.call(self);

	    var filterByUserId;
	    var activeBreaksMode;
	    var activeTroncMode;
	    var brandPayTypes;
	    let niCategoriesMap;
	    var applyBonus;
	    var settings = {};
	    var budgetingHoursData = {};
        var philippinesPremiums = {};
        var isViewFullLaborAndWagePercentagesEnabled = false;
        var philippinesPremiumsTypes = [];
        var positionsWithNoAccessPayRateMap = {};
        var workedDaysData;
        var PH_HOLIDAYS_RATES = {REGULAR_HOLIDAY: 2, SPECIAL_NON_WORKING_DAY: 1.3, SPECIAL_NON_WORKING_DAY_WITH_REST: 1.5, REST_DAY: 1.3};
        var OT_RATES = {DEFAULT: 1.5, PH_OT: 1.25, PH_REGULAR_HOLIDAY: 1.3, PH_SPECIAL_NON_WORKING_DAY: 1.3, PH_REST_DAY: 1.3};

        const WorkLimitResponseValue = {
            IN: 'IN',
            OUT: 'OUT',
            NO_RESPONSE: 'NO_RESPONSE'
        };

	    self.onReadySubscribers = {};

	    self.onReady = function (name, waitingFor, callback) {
	        var ready = isReady(waitingFor);

            if (ready) {
	            callback();
            }
            else {
                self.onReadySubscribers[name] = {
                    waiting_for: waitingFor,
                    callback: callback
                }
            }
        };

	    var setReady = function (dataType) {
	        self.ready[dataType] = true;

	        for (var subscriberName in self.onReadySubscribers) {
	            var subscriber = self.onReadySubscribers[subscriberName];

	            if (subscriber && isReady(subscriber.waiting_for)) {
	                subscriber.callback();
	                delete self.onReadySubscribers[subscriberName];
                }
            }
        };

	    var isReady = function (waitingFor) {
            var isReady = true;

            for (var i in waitingFor) {
                if (!self.ready[waitingFor[i]]) {
                    isReady = false;
                }
            }

            return isReady;
        };

        self.reset = function () {
            self.ready = {};
            // SCHEDULE data
            self.flatData = {};

            // BRAND settings
            self.minimumWageMap = {};
            self.spreadOfHoursMap = {};
            self.spreadOfHoursModeMap = {};
            self.doubleOvertimeMap = {};
            self.consecutiveDayMap = {};
            self.breaksMap = {};
            self.maxWeeklyMap = {};
            self.maxDailyMap = {};

            // USERS' data
            self.userHoursPerDayMap = {};
            self.userHoursPerCategoryMap = {};
            self.daysFormat = {};
            self.userWeeklyHoursMap = {};
            self.userWeeklyScheduledHoursMap = {};
            self.userNetWeeklyHoursMap = {};
            self.userWeeklyOTHoursMap = {};
            self.userWeeklyDoubleOTHoursMap = {};
            self.jobTitlesAllocationHoursMap = {};
            self.userDailyHoursMap = {};
            self.userDailyOTHoursMap = {};
            self.userDailyDoubleOTHoursMap = {};
            self.userNetDailyHoursMap = {};
            self.userDailySpreadHours = {};
            self.userConsecutiveHoursMap = {};
            self.userWeeklyBlendedFinancialMap = {};
            self.userCostPerDayMap = {};
            self.userRestDayMap = {};

            self.salariedUserShiftsLocations = {};
            self.paytypeCategories = {};
            self.paytypePositions = {};
            self.unassignedShiftsMap = {};

            self.userScheduledShifts = {};
            self.userScheduledHours = {};

            self.userPrimaryLocationWorkingMap = {};

            applyBonus = undefined;
            workedDaysData = null;
        };

        self.reset();

        self.isSpreadOfHoursV2Enabled = (startDate) => {
            let isSpreadOfHoursV2Enabled = false;

            if (self.spreadOfHoursMap?.[startDate]?.hours) {
                isSpreadOfHoursV2Enabled = self.spreadOfHoursMap?.[startDate]?.version === 2;
            }

            return isSpreadOfHoursV2Enabled;
        };

        const getSpreadOfHoursModeIntervalForDate = (spreadOfHoursMode, selectedDate) => {
            return spreadOfHoursMode?.reduce((selectedInterval, modeInterval) => {
                const spreadOfHoursModeStartDate = moment(modeInterval.start_date);

                if (spreadOfHoursModeStartDate.isSameOrBefore(selectedDate, 'day') &&
                    (
                        !selectedInterval.start_date ||
                        spreadOfHoursModeStartDate.isAfter(selectedInterval.start_date, 'day')
                    )
                ) {
                    selectedInterval = {...modeInterval};
                }
                return selectedInterval;
            }, {start_date: null, mode: null}) ?? {}
        }

	    // check if nevada overtime settings enabled at least on one day within the week
        // to get schedule data for day before the week
        self.isNevadaOvertimeSettingsEnabled = function () {
            var isNevadaOvertimeSettingsEnabled = false;

            if (Array.isArray(self.brand_daily_cost_settings)) {
                for (var i in self.brand_daily_cost_settings) {
                    var dailyCostSettings = self.brand_daily_cost_settings[i];
                    var brandMaxDailyHours = dailyCostSettings.brand_max_daily_hours || {};

                    if (brandMaxDailyHours.type === 'NEVADA_DAILY') {
                        isNevadaOvertimeSettingsEnabled = true;
                        break;
                    }
                }
            }

            return isNevadaOvertimeSettingsEnabled;
        };

        const isExtraPayEnabled = (extraPaySettings, dateToCheck) => {
            let isEnabled = false;

            for (const setting of extraPaySettings) {
                if (moment(dateToCheck).isSameOrAfter(moment(setting.start_date))) {
                    isEnabled = !!setting.enable_station_extra_pay;
                    break;
                }
            }
            return isEnabled;
        };

        self.setBreaksMap = (breaksMap) => {
            self.breaksMap = breaksMap;
        }

        self.parseCosts = function (costs, startDate) {

	        // reset BRAND settings when parsing costs for another week
	        self.minimumWageMap = {};
	        self.unassignedShiftsMap = {};
	        self.spreadOfHoursMap = {};
            self.spreadOfHoursModeMap = {};
	        self.doubleOvertimeMap = {};
	        self.consecutiveDayMap = {};
	        self.breaksMap = {};
	        self.maxWeeklyMap = {};
	        self.maxDailyMap = {};
            self.userRestDayMap = {};

            var rawScheduleCosts = $.extend({}, costs);
            self.startDate = startDate;
            // endDate is needed to keep track of weekly consecutive overtime (7th day overtime)
            self.endDate = moment(self.startDate, "MMM DD, YYYY").add(6, 'days').format("MMM DD, YYYY");

	        self.brand_daily_cost_settings = costs.brand_daily_cost_settings;
            self.brand_weekly_cost_settings = costs.brand_weekly_cost_settings && costs.brand_weekly_cost_settings[0] || {};
            philippinesPremiums = scheduleDataServiceV2.getPhilippinesOverTimeSettings();
            philippinesPremiumsTypes = Object.keys(philippinesPremiums) || [];
            self.isGuestOTEnabled = (
                self.brand_weekly_cost_settings["brand_max_weekly_hours"] &&
                self.brand_weekly_cost_settings["brand_max_weekly_hours"]["eligibility_location_precedence"] === "SECONDARY"
            );

	        // Map each brand setting to its corresponding schedule daily date
	        for (var q in self.brand_daily_cost_settings) {

		        self.minimumWageMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_daily_cost_settings[q]["minimum_wage"];
		        self.spreadOfHoursMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_daily_cost_settings[q]["spread_of_hours"];
		        self.spreadOfHoursModeMap[self.brand_daily_cost_settings[q]["date"]] = getSpreadOfHoursModeIntervalForDate(costs.spread_of_hours_mode, self.brand_daily_cost_settings[q]["date"]);
		        self.doubleOvertimeMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_daily_cost_settings[q]["double_ot"];
		        self.consecutiveDayMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_daily_cost_settings[q]["consecutive_day"];
		        self.breaksMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_daily_cost_settings[q]["breaks"];
                self.maxWeeklyMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_weekly_cost_settings["brand_max_weekly_hours"];
		        self.maxDailyMap[self.brand_daily_cost_settings[q]["date"]] = self.brand_daily_cost_settings[q]["brand_max_daily_hours"];
	        }

	        var mapped_costs = {};
	        rawScheduleCosts.users = rawScheduleCosts.users || [];

	        for (var a = 0; a < rawScheduleCosts.users.length; a++) {

                var user = rawScheduleCosts.users[a];
                var userInfo = tsUsersService.users[user.user_id] || user;

		        mapped_costs[user.user_id] = {
                    is_health_insurance_offeree: userInfo.is_health_insurance_offeree,
                    user_id: user.user_id,
                    harri_user_id: userInfo.harri_user_id,
                    deactivated: user.schedulable === 'NONE' || userInfo.mode === 'GUEST',
                    pay_type: {},
                    annual_rate: {},
                    shifts_per_week: {},
                    max_weekly_hours: {},
                    tronc: {},
                    ni: {},
                    pension: {},
                    additional_cost: {},
                    positions: user.positions || [],
                    primary_brands: {},
                    work_limits: {},
                    extra_pays: {}
                };

                if (user.work_limit_responses) {
                    for (let dayWorkLimit of user.work_limit_responses) {
                        mapped_costs[user.user_id]["work_limits"][dayWorkLimit["date"]] = dayWorkLimit;
                    }
                }

                user.extra_pays ??= [];
                for (let extraPay of user.extra_pays) {
                    mapped_costs[user.user_id]["extra_pays"][extraPay["date"]] = extraPay;
                }

                for (var brand in user.primary_brands) {
                    var userPrimaryBrand = user.primary_brands[brand];
                    mapped_costs[user.user_id]["primary_brands"][userPrimaryBrand["date"]] = userPrimaryBrand;
                }

                for (var rate in user.annual_rate) {
                    var userAnnualRate = user.annual_rate[rate];
                    mapped_costs[user.user_id]["annual_rate"][userAnnualRate["date"]] = userAnnualRate;
                }

                for (var pay in user.pay_type) {
                    var userPayType = user.pay_type[pay];
                    mapped_costs[user.user_id]["pay_type"][userPayType["date"]] = userPayType;


                    // map daily salaried costs for users
                    mapped_costs[user.user_id]["weekly_salaried_cost"] ??= 0;
                    mapped_costs[user.user_id]["salaried_days"] = mapped_costs[user.user_id]["salaried_days"] || {};
                    mapped_costs[user.user_id]["salaried_days"][userPayType.date] = mapped_costs[user.user_id]["salaried_days"][userPayType.date] || {};

                    mapped_costs[user.user_id]["salaried_days"][userPayType.date]["salaried"] = (userPayType.type === self.PAY_TYPES.SALARIED);

                    if (userPayType.type === self.PAY_TYPES.SALARIED) {
                        var userAnnualRatePerDay =
                            (mapped_costs[user.user_id]["annual_rate"][userPayType.date]
                                && mapped_costs[user.user_id]["annual_rate"][userPayType.date]["value"])
                            || 0;

                        var userPayPerDay = (parseInt(userAnnualRatePerDay) / 100 / WEEKS_PER_YEAR / 7 * 100) / 100;

                        mapped_costs[user.user_id]["salaried_days"][userPayType.date]["cost"] = userPayPerDay;
                        mapped_costs[user.user_id]["weekly_salaried_cost"] += userPayPerDay;
                    }
                }

                for (var shifts in user.shifts_per_week) {
		            var userShiftsPerWeek = user.shifts_per_week[shifts];
		            mapped_costs[user.user_id]["shifts_per_week"][userShiftsPerWeek["date"]] = userShiftsPerWeek;
                }

                for (var max in user.max_weekly_hours) {
		            var userMaxWeeklyHours = user.max_weekly_hours[max];
		            mapped_costs[user.user_id]["max_weekly_hours"][userMaxWeeklyHours["date"]] = userMaxWeeklyHours;
                }

                for (var tronc in user.tronc) {
		            var userTronc = user.tronc[tronc];
		            mapped_costs[user.user_id]["tronc"][userTronc["date"]] = userTronc;
                }

                for (var ni in user.ni) {
                    var niValue = user.ni[ni];
                    mapped_costs[user.user_id]["ni"][niValue["date"]] = niValue;
                }

                for (var pen in user.pension) {
                    var pension = user.pension[pen];
                    mapped_costs[user.user_id]["pension"][pension["date"]] = pension;
                }

                if (user.additional_costs) {
                    for (var cost in user.additional_costs) {
                        var userAdditionalCost = user.additional_costs[cost];
                        mapped_costs[user.user_id]["additional_cost"][userAdditionalCost["date"]] = userAdditionalCost;
                    }
                }

                if (user['positions']) {

                    var userMappedCost = mapped_costs[user.user_id];

                    for (var b = 0; b < user['positions'].length; b++) {

                        var position = user['positions'][b];
                        var userMappedPositionCost = {
                            position_code: position.position_code,
                            deleted: position.deleted,
                            allow_access: position.allow_access
                        };

                        userMappedCost[position.position_code] = userMappedPositionCost;

                        if (position.pay_rates) {
                            if (position.allow_access) {
                                userMappedPositionCost = $.extend(userMappedPositionCost, preparePositionPayRatesPerDayMap(position, user.user_id));
                            } else {
                                positionsWithNoAccessPayRateMap[user.user_id] = positionsWithNoAccessPayRateMap[user.user_id] || {};
                                positionsWithNoAccessPayRateMap[user.user_id][position.position_code] = $.extend({}, userMappedPositionCost, preparePositionPayRatesPerDayMap(position, user.user_id));
                            }
                        }
			        }
		        }
	        }

	        // map deactivated users cost
            // deactivated users have scheduled shifts but not returned in cost api
            var scheduleUsersIds = scheduleDataServiceV2.flatData && Object.keys(scheduleDataServiceV2.flatData['users']) || [];
            var costUsersIds = Object.keys(mapped_costs) || [];

            for (var i in scheduleUsersIds) {
                var userId = scheduleUsersIds[i];

                if (!isNaN(userId) && costUsersIds.indexOf(userId) === -1) {
                    var userInfo = tsUsersService.users[userId] || {};

                    mapped_costs[userId] = {
                        is_health_insurance_offeree: userInfo.is_health_insurance_offeree,
                        user_id: userId,
                        harri_user_id: userInfo.harri_user_id,
                        deactivated: user && user.schedulable === 'NONE' || userInfo.mode === 'GUEST',
                        pay_type: {},
                        annual_rate: {},
                        shifts_per_week: {},
                        max_weekly_hours: {},
                        tronc: {},
                        ni: {},
                        pension: {},
                        additional_cost: {},
                        primary_brands: {},
                        extra_pays: {}
                    };
                }
            }

	        self.flatData['costs'] = mapped_costs;
        };

        self.getUsersCostsMap = function () {
            var defer = $q.defer();
            defer.resolve(angular.copy(self.flatData['costs']));
            return defer.promise;
        };

	    self.setFilterByUserId = function (userId) {
		    filterByUserId = userId;
	    };

        var preparePositionPayRatesPerDayMap = function (position, userId) {
            var userMappedPositionCost = {};

            for (var c = 0; c < position.pay_rates.length; c++) {

                var payRate = position.pay_rates[c];

                if (payRate) {
                    var brandDailyCostsForDay = getBrandDailyCostsForDay(payRate.date) || {};

                    userMappedPositionCost[payRate.date] = {
                        user_id: userId,
                        brand_max_weekly_hours: getMaxWeeklyHours(),
                        brand_max_daily_hours: getMaxDailyHoursForDay(payRate.date),
                        position_code: position.position_code,
                        role_day_date: payRate.date,
                        rate: payRate.rate || 0,
                        currency: payRate.currency,
                        deleted: position.deleted,
                        minimum_wage: brandDailyCostsForDay["minimum_wage"],
                        spread_of_hours: brandDailyCostsForDay["spread_of_hours"],
                        double_ot: brandDailyCostsForDay["double_ot"],
                        consecutive_day: brandDailyCostsForDay["consecutive_day"],
                        breaks: brandDailyCostsForDay["breaks"],
                        tronc: payRate.tronc
                    };
                }
            }

            if (position['is_tipped_ranges']) {
                for (var c in position['is_tipped_ranges']) {
                    var positionIsTippedObj = position['is_tipped_ranges'][c];

                    if (userMappedPositionCost[positionIsTippedObj.date]) {
                        userMappedPositionCost[positionIsTippedObj.date].is_tipped = positionIsTippedObj['value'];
                    }
                }
            }

            return userMappedPositionCost;
        }

	    var calculateShiftPeriod = function(shift) {
            var period = (shift.calculatedEnd - shift.calculatedStart) / MILLISECOND;

            if (!settings['schedule'].add_unpaid_breaks_hours_to_total_hours) {
                period = shift.costInfo.time;
            }
            else {
                var isScheduledBreaksEnabled = settings['schedule']['shift_break_times_mode'] === "MANUAL_ENTRY";
                if (isScheduledBreaksEnabled && !settings['schedule'].add_unpaid_scheduled_breaks_hours_to_total_hours) {
                    if(shift.breaks.length) {
                        var breaks = angular.copy(shift.breaks);
                        for (var i in breaks) {
                            var breakItem = breaks[i];
                            var isScheduledUnpaidBreak = breakItem['start_time'] && breakItem['end_time'] && [self.BREAKS_TYPES.UNPAID, self.BREAKS_TYPES.SPLIT_SHIFT].indexOf(breakItem['type']) > -1;
                            if (isScheduledUnpaidBreak) {
                                period -= getBreakTimeWithinShift(shift.calculatedStart, shift.calculatedEnd, shift.day, breakItem);
                            }
                        }
                    }
                }
            }
            return period / HOUR;
        };

        var calculateOTForDayBefore = function (allShifts) {
            var userWorkingMap = {};
            var brand_max_daily_seconds = self.maxDailyMap[scheduleDataServiceV2.startDate] && self.maxDailyMap[scheduleDataServiceV2.startDate]["hours"] * HOUR;

            for (var i in allShifts) {
                var shift = allShifts[i];

                if (shift.user_id) {
                    var start = new Date(shift.start_time).getTime();
                    var end = new Date(shift.end_time).getTime();
                    var shiftTime = (end - start) / MILLISECOND;

                    userWorkingMap[shift.user_id] = userWorkingMap[shift.user_id] || {hours: 0};
                    userWorkingMap[shift.user_id]['hours'] += shiftTime;
                    shift.costInfo = {net_time: shiftTime};

                    if (brand_max_daily_seconds && (userWorkingMap[shift.user_id]['hours'] > brand_max_daily_seconds)) {
                        var otDifference = userWorkingMap[shift.user_id]['hours'] - brand_max_daily_seconds;
                        var shiftOvertime = otDifference > shiftTime? shiftTime: otDifference;

                        shift.costInfo['daily_overtime'] = shiftOvertime;
                        shift.costInfo['net_time'] -= shiftOvertime;
                    }
                }
            }
        };

        self.isPhilippinesOverTimeSettingsEnabled = function (overTimeSettingsCode, selectedDay) {
            if (philippinesPremiums[overTimeSettingsCode] && philippinesPremiums[overTimeSettingsCode].days) {
                if (selectedDay) {
                    return philippinesPremiums[overTimeSettingsCode].days[selectedDay];
                }
                return true;
            }
            return false;
        }

        var getRateFactor = function (day, teamLiveCountryCode, isPhilippineRestDay) {
            var rate = isPhilippineRestDay? PH_HOLIDAYS_RATES['REST_DAY']: 1;
            var overtimeRate = (self.maxDailyMap[day] && self.maxDailyMap[day]['rate']) || (teamLiveCountryCode === 'PH'? 0.25: 0.5);
            var overtimeFactor = teamLiveCountryCode === 'PH'? OT_RATES['PH_OT']: OT_RATES['DEFAULT'];
            var holidays = Object.keys(scheduleDataServiceV2.brandHolidays[day] || {});
            var isRegularHolidayOvertimeEnabled = self.isPhilippinesOverTimeSettingsEnabled('REGULAR_HOLIDAY', day);
            var isSpecialDayOvertimeEnabled = self.isPhilippinesOverTimeSettingsEnabled('SPECIAL_NON_WORKING_DAY', day);

            if (isRegularHolidayOvertimeEnabled && holidays.indexOf('REGULAR_HOLIDAY') > -1) {
                rate *= PH_HOLIDAYS_RATES['REGULAR_HOLIDAY'];
                overtimeFactor = Utils.roundFloat(rate * OT_RATES['PH_REGULAR_HOLIDAY']);
            } else if (isSpecialDayOvertimeEnabled && holidays.indexOf('SPECIAL_NON_WORKING_DAY') > -1) {
                var specialDayRate = isPhilippineRestDay? PH_HOLIDAYS_RATES['SPECIAL_NON_WORKING_DAY_WITH_REST']: PH_HOLIDAYS_RATES['SPECIAL_NON_WORKING_DAY'];
                rate = specialDayRate;
                overtimeFactor = Utils.roundFloat(rate * OT_RATES['PH_SPECIAL_NON_WORKING_DAY']);
            } else if (isPhilippineRestDay) {
                overtimeFactor = Utils.roundFloat(rate * OT_RATES['PH_REST_DAY']);
            }
            overtimeRate = Utils.roundFloat(overtimeFactor - rate);
            return {rate: rate, overtimeRate: overtimeRate, overtimeFactor: overtimeFactor};
        };

        var getUserPreviousWork = function (day, userWork) {
            var userHours = 0;

            for (var c = 0; c < 21; c++) {
                var date = moment(day).clone().subtract(c, 'days').format("MMM DD, YYYY");
                var dayWork = userWork[date];

                if (dayWork && dayWork['total_hours']) {
                    userHours = dayWork['total_hours'];
                    break;
                }
            }

            return userHours;
        };

        var isExpectedRestDay = function (day, userWork) {
            if (philippinesPremiumsTypes.indexOf('REST_DAY') === -1) {
                return false;
            }

            if (userWork[day] && userWork[day]['hasWork']) {
                return false;
            }

            var workCounter = 0;

            for (var c = 1; c < 7; c++) {
                var date = moment(day).clone().subtract(c, 'days').format("MMM DD, YYYY");
                var dayWork = userWork[date];

                if (dayWork && dayWork['total_hours']) {
                    workCounter++;
                }
            }

            return workCounter === 6;
        };

        var getPeriodExcludeUnpaidBreak = function (startTime, endTime, day, breaks) {
            var breakPortions = [];
            for (var i in breaks) {
                var breakItem = breaks[i];

                var breakDuration = getBreakTimeWithinShift(startTime, endTime, day, breakItem);
                if (breakDuration > 0) {
                    var breakPeriod = shiftTemplateUtils.getPeriod(breakItem.start_time, breakItem.end_time, day);
                    startTime -= breakDuration * MILLISECOND;
                    breakPortions.push({
                        start_time: Math.max(startTime, breakPeriod.start.getTime()),
                        end_time: Math.min(endTime, breakPeriod.end.getTime())
                    });
                }
            }
            return {
                startTime: startTime,
                endTime: endTime,
                breakPortions: breakPortions,
            }
        };

        self.getShiftCostPeriod = function (shift) {
            var periods = {
                overtime: null,
                differential_pay: shift.costInfo.diff_rules,
            };
            var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

            var otDuration = (
                shift.costInfo.daily_overtime +
                shift.costInfo.daily_double_overtime +
                shift.costInfo.weekly_overtime +
                shift.costInfo.weekly_double_overtime +
               (shift.costInfo.guest_weekly_overtime || 0)
            );
            var otKeys = [
                'weekly_double_overtime',
                'weekly_overtime',
                'guest_weekly_overtime',
                'daily_double_overtime',
                'daily_overtime',
            ];

            if (otDuration > 0) {
                periods.overtime = {};
                var endTime = shift.calculatedEnd;
                for (var i in otKeys) {
                    var otKey = otKeys[i];
                    if (shift.costInfo[otKey] > 0 && shift.costInfo.over_times[otKey]) {
                        var duration = shift.costInfo[otKey] * MILLISECOND;
                        var overtimeEnd = endTime;
                        var overtimeStart = overtimeEnd - duration;
                        periods.overtime[otKey] = {
                            period: getPeriodExcludeUnpaidBreak(overtimeStart, overtimeEnd, shiftDay, shift.unpaidBreaks),
                            duration: duration,
                            cost: shift.costInfo.over_times[otKey].cost,
                            rate: shift.costInfo.over_times[otKey].cost / ((duration / (HOUR * MILLISECOND))),
                        };
                        endTime = endTime - (periods.overtime[otKey].period.endTime - periods.overtime[otKey].period.startTime);
                    }
                }
            }

            return periods;
        }

        const handleAbsencesForSalariedEmployees = () => {
            const brand = teamScheduleService.getBrandById(scheduleDataServiceV2.brandId);
            const absences = [...(brand.absences.filter(absence => absence !== 'LOA') ?? []), 'CUSTOM'];

            if (!scheduleDataServiceV2.availabitlies) {
                return;
            }

            for (const userId in self.flatData.costs) {
                const userCostsDetails = self.flatData.costs[userId];
                const userAvailabilities = scheduleDataServiceV2.availabitlies[userId] ?? [];

                if (userCostsDetails.salaried_days) {
                    for (const availability of userAvailabilities) {
                        const day = scheduleDataServiceV2.getShiftDay(availability);
                        const salariedDay = userCostsDetails.salaried_days[day];
                        if (salariedDay?.salaried) {
                            if (availability.type === 'LOA' && salariedDay.salaried && salariedDay.cost > 0) {
                                userCostsDetails.weekly_salaried_cost -= salariedDay.cost;
                                salariedDay.cost = 0;
                            } else if (absences.includes(availability.type) && availability.is_all_day && availability.weight > 0 && salariedDay.salaried && salariedDay.cost > 0 && !settings?.schedule?.include_non_working_days_to_salaried_cost) {
                                self.salariedUserShiftsLocations[userId] ??= {days: {}, working_days_count: 0};
                                if (!self.salariedUserShiftsLocations[userId].days[day]) {
                                    self.salariedUserShiftsLocations[userId].days[day] ??= {locations_map: {}, locations_count: 0};
                                    self.salariedUserShiftsLocations[userId].working_days_count++;
                                }
                                if (!self.salariedUserShiftsLocations[userId].days[day].locations_map[scheduleDataServiceV2.brandId]) {
                                    self.salariedUserShiftsLocations[userId].days[day].locations_map[scheduleDataServiceV2.brandId] = true;
                                    self.salariedUserShiftsLocations[userId].days[day].locations_count++;
                                }
                            }
                        }
                    }
                }
            }
        };

        var getDayHourMap = function (dayDate) {
            var hoursMap = {};

            var dayOpen = moment(moment(dayDate).format("MMM DD, YYYY")).valueOf();
            var dayOffset = new Date(dayOpen).getTimezoneOffset();
            var dayOpenOffset = new Date(dayOpen + scheduleDataServiceV2.dayOpenHour).getTimezoneOffset();
            var dayCloseOffset = new Date(dayOpen + scheduleDataServiceV2.dayCloseHour).getTimezoneOffset();
            var dayOpenHour = scheduleDataServiceV2.dayOpenHour + ((dayOpenOffset - dayOffset) * 60 * 1000);
            var dayCloseHour = scheduleDataServiceV2.dayCloseHour + ((dayCloseOffset - dayOffset) * 60 * 1000);

            var openTime = Math.floor(dayOpenHour / (HOUR * MILLISECOND));
            var closeTime = Math.ceil(dayCloseHour / (HOUR * MILLISECOND));
            var startTime = moment(dayDate).startOf('day').add(openTime, 'hours');
            var endTime = moment(dayDate).startOf(dayDate).add(closeTime, 'hours');
            var time = startTime.clone();

            while (time.isBefore(endTime)) {
                hoursMap[time.format('YYYY-MM-DDTHH:mm:ssZ')] = {
                    hour: time.valueOf(),
                    nextHour: time.valueOf() + HOUR * MILLISECOND,
                    cost: 0,
                };
                time = time.add(1, 'hours');
            }

            return hoursMap;
        };

        self.setBreakTimeAtShiftEndTimeIfUnscheduled = function (shiftDayOffset, shiftEndTime, breakItem) {
            var scheduledBreakItem = angular.copy(breakItem);
            if (!breakItem.start_time || !breakItem.end_time) {
                scheduledBreakItem = {
                    start_time: Math.floor(((shiftEndTime - shiftDayOffset) - ((parseInt(breakItem.duration) || 0) * MILLISECOND)) / MILLISECOND),
                    end_time: Math.floor((shiftEndTime - shiftDayOffset) / MILLISECOND)
                }
            }

            return scheduledBreakItem;
        }

        self.calculatePerHour = function (shifts) {
            var viewData = {
                users: {},
                total_shifts: {},
                total_hours: {},
            };

            for (var i in shifts) {
                var shift = shifts[i];
                var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

                if (!shift.user_id) {
                    continue;
                }

                if (['DELETED'].indexOf(shift.status) > -1) {
                    continue;
                }

                if (shift.payType && shift.payType.type === 'SALARIED') {
                    continue;
                }

                viewData.total_shifts[shiftDay] = (viewData.total_shifts[shiftDay] || 0) + (shift.weight || 1);
                viewData.total_hours[shiftDay] = (viewData.total_hours[shiftDay] || 0) + (shift.period || 0);

                var shiftCostPeriods = self.getShiftCostPeriod(shift);
                var otCost = 0;
                if (shiftCostPeriods.overtime) {
                    for (var i in shiftCostPeriods.overtime) {
                        otCost += shiftCostPeriods.overtime[i].cost;
                    }
                }

                var weightedShiftOtRate = shift.costInfo.overtimeCost / (shift.costInfo.overtimeHours / HOUR);

                var diffCost = 0;
                for (var j in shiftCostPeriods.differential_pay) {
                    diffCost += shiftCostPeriods.differential_pay[j].cost;
                }

                var regularCost = shift.costInfo.cost - diffCost - otCost;

                var regularRate = (shift.costInfo.time > 0) ? (regularCost / (shift.costInfo.time / HOUR)) : 0;

                viewData.users[shift.user_id] = viewData.users[shift.user_id] || {days: {}};
                viewData.users[shift.user_id].days[shiftDay] = viewData.users[shift.user_id].days[shiftDay] || getDayHourMap(shiftDay);

                var selectedDayOffset = moment(shiftDay).zone(0).valueOf();
                for (var j in viewData.users[shift.user_id].days[shiftDay]) {
                    var hourPeriod = viewData.users[shift.user_id].days[shiftDay][j];
                    var minLimit = Math.max(shift.calculatedStart, hourPeriod.hour);
                    var maxLimit = Math.min(shift.calculatedEnd, hourPeriod.nextHour);

                    // regular pay cost.
                    if (minLimit <= maxLimit) {
                        var breakDuration = 0;
                        for (var k in shift.unpaidBreaks) {
                            var breakItem = shift.unpaidBreaks[k];
                            breakItem = self.setBreakTimeAtShiftEndTimeIfUnscheduled(selectedDayOffset, shift.calculatedEnd, breakItem);
                            breakDuration += getBreakTimeWithinShift(minLimit, maxLimit, shiftDay, breakItem) * MILLISECOND;
                        }
                        var portion = (maxLimit - minLimit - breakDuration) / (HOUR * MILLISECOND);
                        if (portion > 0) {
                            hourPeriod.cost += portion * regularRate;
                        }
                    }

                    if (shift.costInfo.overtimeHours) {
                        var minLimit = Math.max(shift.calculatedEnd - (shift.costInfo.overtimeHours * MILLISECOND), hourPeriod.hour);
                        var maxLimit = Math.min(shift.calculatedEnd, hourPeriod.nextHour);

                        //uk weighted shift overtime.
                        if (minLimit <= maxLimit) {
                            var breakDuration = 0;
                            for (var k in shift.unpaidBreaks) {
                                var breakItem = shift.unpaidBreaks[k];
                                breakItem = self.setBreakTimeAtShiftEndTimeIfUnscheduled(selectedDayOffset, shift.calculatedEnd, breakItem);
                                breakDuration += getBreakTimeWithinShift(minLimit, maxLimit, shiftDay, breakItem) * MILLISECOND;
                            }
                            var portion = (maxLimit - minLimit - breakDuration) / (HOUR * MILLISECOND);
                            if (portion > 0) {
                                hourPeriod.cost += portion * weightedShiftOtRate;
                            }
                        }
                    }

                    // overtime pay cost.
                    if (shiftCostPeriods.overtime) {
                        for (var k in shiftCostPeriods.overtime) {
                            var overtime = shiftCostPeriods.overtime[k];
                            minLimit = Math.max(overtime.period.startTime, hourPeriod.hour);
                            maxLimit = Math.min(overtime.period.endTime, hourPeriod.nextHour);

                            if (minLimit <= maxLimit) {
                                var breakDuration = 0;
                                for (var l in overtime.period.breakPortions) {
                                    var breakPeriod = overtime.period.breakPortions[l];
                                    breakPeriod = self.setBreakTimeAtShiftEndTimeIfUnscheduled(selectedDayOffset, shift.calculatedEnd, breakPeriod);
                                    var breakMinLimit = Math.max(minLimit, breakPeriod.start_time);
                                    var breakMaxLimit = Math.min(maxLimit, breakPeriod.end_time);
                                    if (breakMinLimit <= breakMaxLimit) {
                                        breakDuration += breakMaxLimit - breakMinLimit;
                                    }
                                }
                                var overtimePortion = (maxLimit - minLimit - breakDuration) / (HOUR * MILLISECOND);
                                if (overtimePortion > 0) {
                                    hourPeriod.cost += overtimePortion * overtime.rate;
                                }
                            }
                        }
                    }

                    // differential pay cost.
                    if (shiftCostPeriods.differential_pay.length) {
                        var differentialPayCost = 0;
                        for (var k in shiftCostPeriods.differential_pay) {
                            var differentialRule = shiftCostPeriods.differential_pay[k];
                            for (var l in differentialRule.appliedPeriods) {
                                var differentialPeriod = differentialRule.appliedPeriods[l];
                                var differentialPeriodStart = selectedDayOffset + (differentialPeriod.start * MILLISECOND);
                                var differentialPeriodEnd = selectedDayOffset + (differentialPeriod.end * MILLISECOND);
                                var periodMinLimit = Math.max(differentialPeriodStart, hourPeriod.hour);
                                var periodMaxLimit = Math.min(differentialPeriodEnd, hourPeriod.nextHour);
                                if (periodMinLimit <= periodMaxLimit) {
                                    var breakDuration = 0;
                                    for (var j in shift.unpaidBreaks) {
                                        var breakItem = shift.unpaidBreaks[j];
                                        breakItem = self.setBreakTimeAtShiftEndTimeIfUnscheduled(selectedDayOffset, shift.calculatedEnd, breakItem);
                                        breakDuration += getBreakTimeWithinShift(periodMinLimit, periodMaxLimit, shiftDay, breakItem) * MILLISECOND;
                                    }
                                    var differentialPayPortion = ((periodMaxLimit - periodMinLimit - breakDuration) / (MILLISECOND * HOUR));
                                    if (differentialPayPortion > 0) {
                                        differentialPayCost += differentialPayPortion * differentialRule.amount;
                                    }
                                }
                            }
                        }
                        hourPeriod.cost += differentialPayCost;
                    }
                }
            }

            return viewData;
        }

        const isShiftDayThe7thDay = (shiftDay, daysWorked, endDate) => {
            return (
                self.consecutiveDayMap[shiftDay]?.is_activated &&
                daysWorked === 7 &&
                shiftDay === endDate
            );
        }

        const addShiftDayToDaysMap = (daysFormat, shiftStartDate, shiftDay) => {
            if (!daysFormat[shiftStartDate]) {
                daysFormat[shiftStartDate] = {
                    previousDay: _scheduleDateUtilsService.moment(shiftStartDate).clone().subtract(1, 'days').format('MMM DD, YYYY'),
                    currentDay: _scheduleDateUtilsService.moment(shiftStartDate).format('MMM DD, YYYY'),
                    nextDay: _scheduleDateUtilsService.moment(shiftStartDate).clone().add(1, 'days').format('MMM DD, YYYY'),
                }
            }

            if (!daysFormat[shiftDay]) {
                daysFormat[shiftDay] = {
                    previousDay: _scheduleDateUtilsService.moment(shiftDay).clone().subtract(1, 'days').format('MMM DD, YYYY'),
                    currentDay: _scheduleDateUtilsService.moment(shiftDay).format('MMM DD, YYYY'),
                    nextDay: _scheduleDateUtilsService.moment(shiftDay).clone().add(1, 'days').format('MMM DD, YYYY'),
                }
            }

            return daysFormat;
        }

        const checkIfShiftExceedSpreadOfHours = (shift, shiftDay, sohVersionDayCheck, shiftCalendarDay, spreadOfHoursMap, spreadOfHoursModeMap, userDailySpreadHours, calculatedStart, calculatedEnd, shiftStart, shiftEnd) => {
            const shiftLength = shift.length * MILLISECOND;
            const spreadOfHoursMode = spreadOfHoursModeMap[sohVersionDayCheck]?.mode;
            const spreadOfHoursAllowedPeriodTime = (spreadOfHoursMap[sohVersionDayCheck]?.hours ?? 0) * MILLISECOND;
            let violateSpreadOfHours = false;

            if (spreadOfHoursAllowedPeriodTime && spreadOfHoursMode === SPREAD_OF_HOURS_MODES_MAP.BUSINESS_DAY) {
                // v1 is the old behavior of SOH which was checking the SOH on business day.

                userDailySpreadHours[shift.user_id][shiftDay] ??= {exceeded: false};
                // spread of hours -> hours value from api in seconds not hours
                // calculation of spread of hours is done in milliseconds
                const spreadStart = userDailySpreadHours[shift.user_id][shiftDay].start = (userDailySpreadHours[shift.user_id][shiftDay].start || calculatedStart);
                const spreadEnd = userDailySpreadHours[shift.user_id][shiftDay].end = calculatedEnd;

                // check period between start of first shift and the end of last shift
                // (or if one shift start and end of it) if it exceeds spread of hour period
                const spreadPeriod = userDailySpreadHours[shift.user_id][shiftDay].spread_period = spreadEnd - spreadStart;

                if ((
                    (spreadPeriod > spreadOfHoursAllowedPeriodTime) ||
                    (shift.isExtendedOverNextDay && shiftLength > spreadOfHoursAllowedPeriodTime)
                ) && !userDailySpreadHours[shift.user_id][shiftDay].exceeded
                ) {
                    // set the daily spread of hours so that the employee doesn't take two SOH at the same business day.
                    userDailySpreadHours[shift.user_id][shiftDay].exceeded = true;
                    violateSpreadOfHours = true;
                }
            } else if (spreadOfHoursMap[sohVersionDayCheck]?.hours && spreadOfHoursMode === SPREAD_OF_HOURS_MODES_MAP.CALENDAR_DAY && !shift.isExtendedFromPreviousDay) {
                // v2 is the new behavior which checks the spread of hours on the calendar day.

                const currentDay = shiftCalendarDay.currentDay;
                const previousDay = shiftCalendarDay.previousDay;
                const previousShift = userDailySpreadHours[shift.user_id][currentDay]?.start ? userDailySpreadHours[shift.user_id][currentDay] : userDailySpreadHours[shift.user_id][previousDay];
                const periodLength = shiftEnd - previousShift.start;
                const spreadPeriodBetweenPreviousEndAndCurrentShiftStart = shiftStart - previousShift.end;

                // first we check if the shift length > SOH period, if yes then we give the employee SOH
                // if no then we check if the employee had previous shifts, if they had previous shifts
                // we will check if the period from the end of the current shift to the start of previous shift is > SOH period
                // if yes then we will give you SOH if the shift is within the same day
                // if yes and the previous shift wasn't in the same calendar day then we will check the period between the current shift start and previous shift end is < 12 hours
                // if less than 12 hours we will give you SOH
                // otherwise no SOH given
                // NOTE: the SOH cannot be taken on the same calendar day.
                violateSpreadOfHours = (
                    (shiftLength > spreadOfHoursAllowedPeriodTime) ||
                    (
                        userDailySpreadHours[shift.user_id][currentDay]?.start &&
                        (periodLength > spreadOfHoursAllowedPeriodTime)
                    ) ||
                    (
                        userDailySpreadHours[shift.user_id][previousDay]?.start &&
                        (periodLength > spreadOfHoursAllowedPeriodTime) &&
                        (spreadPeriodBetweenPreviousEndAndCurrentShiftStart < (12 * HOUR * MILLISECOND))
                    )
                );

                // save current shift start and end to be used in the future to calculate SOH for other shifts.
                userDailySpreadHours[shift.user_id][currentDay].start ??= shiftStart;
                userDailySpreadHours[shift.user_id][currentDay].end = shiftEnd;
                violateSpreadOfHours &&= !userDailySpreadHours[shift.user_id][currentDay].exceeded;
                userDailySpreadHours[shift.user_id][currentDay].exceeded ||= violateSpreadOfHours;
            }

            return violateSpreadOfHours;
        }

        const checkSohOnExtraDay = () => {
            const previousWeekShifts = [];
            for (const shiftId in scheduleDataServiceV2.extraCrossDayFlatData.shifts) {
                previousWeekShifts.push(scheduleDataServiceV2.extraCrossDayFlatData.shifts[shiftId]);
            }

            for (const shiftId in scheduleDataServiceV2.extraDayFlatData.shifts) {
                previousWeekShifts.push(scheduleDataServiceV2.extraDayFlatData.shifts[shiftId]);
            }

            for (const shift of previousWeekShifts) {
                let start = _scheduleDateUtilsService.moment(shift.start_time).valueOf();
                let end = _scheduleDateUtilsService.moment(shift.end_time).valueOf();
                const shiftDay = shift.day;

                const shiftStartDate = new Date(start).toDateString();
                self.daysFormat = addShiftDayToDaysMap(self.daysFormat, shiftStartDate, new Date(shiftDay).toDateString());

                self.userDailySpreadHours[shift.user_id] ??= {};
                self.userDailySpreadHours[shift.user_id][self.daysFormat[shiftStartDate].currentDay] ??= {exceeded: false};
                self.userDailySpreadHours[shift.user_id][self.daysFormat[shiftStartDate].previousDay] ??= {exceeded: false};

                checkIfShiftExceedSpreadOfHours(shift, shiftDay, scheduleDataServiceV2.startDate, self.daysFormat[shiftStartDate], self.spreadOfHoursMap, self.spreadOfHoursModeMap, self.userDailySpreadHours, start, end, start, end);
            }
        }

        const prepareTier2WageValue = (minWage) => {
            return (minWage?.[1]?.value || minWage?.[0]?.value || 0) / 100;
        }

        const addToShiftCost = function (shift, hoursWorked, hourRate, rateFactor, blendedFinancialMap) {
            const cost = hoursWorked * hourRate * rateFactor;
            shift.costInfo.cost += cost;
            if (blendedFinancialMap && shift.costInfo.allow_access && !shift.cross_location) {
                blendedFinancialMap[shift.user_id].straight_time_cost += cost;
                blendedFinancialMap[shift.user_id].total_hours += hoursWorked;
            }
            return [shift, blendedFinancialMap];
        };

        const getMergedScheduledUnpaidBreaks = (unpaidBreaks, shiftStart, shiftEnd) => {
            let totalDurations = 0;
            let scheduledBreaks = [];
            let mergedBreaks = [];
            let unScheduledBreak;

            for (const shiftBreak of unpaidBreaks) {
                if (!shiftBreak.start_time && !shiftBreak.end_time) {
                    totalDurations += shiftBreak.duration || 0;
                } else {
                    scheduledBreaks.push(shiftBreak);
                }
            }
            scheduledBreaks.sort((a, b) => b.start_time - a.start_time);

            if (totalDurations) {
                let startDate = shiftEnd - (totalDurations * 1000);
                let shiftStartTimeInSeconds = shiftTemplateUtils.timeObjToSeconds(shiftStart).hours + shiftTemplateUtils.timeObjToSeconds(shiftStart).minutes;
                let breakStartInSeconds = shiftTemplateUtils.timeObjToSeconds(startDate).hours + shiftTemplateUtils.timeObjToSeconds(startDate).minutes;

                if (shiftStartTimeInSeconds < (scheduleDataServiceV2.dayOpenHour / MILLISECOND)) {
                    shiftStartTimeInSeconds += DAY;
                }

                if (breakStartInSeconds < shiftStartTimeInSeconds) {
                    breakStartInSeconds += DAY;

                    if (breakStartInSeconds < shiftStartTimeInSeconds) {
                        breakStartInSeconds += DAY;
                    }
                }

                unScheduledBreak = {
                    duration: totalDurations,
                    start_time: breakStartInSeconds,
                    end_time: breakStartInSeconds + totalDurations
                };
                if (scheduledBreaks.length) {
                    for (let scheduledBreak of scheduledBreaks) {
                        const overlapStart = Math.max(scheduledBreak.start_time, unScheduledBreak.start_time);
                        const overlapEnd = Math.min(scheduledBreak.end_time, unScheduledBreak.end_time);
                        if (overlapStart < overlapEnd) {
                            const overlapDuration  = overlapEnd - overlapStart;
                            const minStartTime = Math.min(scheduledBreak.start_time, unScheduledBreak.start_time);
                            unScheduledBreak.start_time = minStartTime - overlapDuration;
                            unScheduledBreak.duration += scheduledBreak.duration;
                        } else {
                            mergedBreaks.push({...scheduledBreak})
                        }
                    }
                    mergedBreaks.push({...unScheduledBreak});
                    return mergedBreaks;
                };
                return [{...unScheduledBreak}];
            };
            return scheduledBreaks;
        };

        const calculateShiftMergedUnpaidBreaks = (shift) => {
            const breaksList = (shift.breaks.length? shift.breaks: shift.break_list) || [];
            const unpaidBreaks = breaksList.filter((shiftBreak) => shiftBreak.type === "UNPAID");
            const shiftEnd = new Date(shift.end_time).getTime();

            return getMergedScheduledUnpaidBreaks(unpaidBreaks, shift.calculatedStart, shiftEnd);
        }

        const calculateJobTitleTimeWithBreaks = (shift, jobTitle, mergedUnpaidBreaks, shiftDay) => {
            let startStationTime = new Date(jobTitle.start_time).valueOf();
            let endStationTime = new Date(jobTitle.end_time).valueOf();

            if (startStationTime < shift.calculatedStart) {
                startStationTime = shift.calculatedStart;
            }

            if (endStationTime > shift.calculatedEnd) {
                endStationTime = shift.calculatedEnd;
            }

            let totalBreaks = 0;

            for (const shiftBreak of mergedUnpaidBreaks) {
                totalBreaks += getBreakTimeWithinShift(startStationTime, endStationTime, shiftDay, shiftBreak) || 0;
            }
            let totalTime = (endStationTime - startStationTime) / MILLISECOND;
            let time = totalTime - totalBreaks
            return (time < 0) ? 0 : (time / 3600);
        }

        const calculateExtraJobStations = (shift, userId, shiftDay) => {
            let intervals = [];
            let userCostsDetails = _jobTitlesDataService.usersExtraJobMap[userId][shiftDay];
            const mergedUnpaidBreaks = calculateShiftMergedUnpaidBreaks(shift);
            if (shift.job_titles?.length) {
                for (const jobTitle of shift.job_titles) {
                    if (userCostsDetails?.[jobTitle.job_title_id]) {
                        const time = calculateJobTitleTimeWithBreaks(shift, jobTitle, mergedUnpaidBreaks, shiftDay);
                        intervals.push({id: jobTitle.job_title_id, rate: userCostsDetails[jobTitle.job_title_id].value, period: time});
                    }

                }
            }
            return intervals;
        };

        const calculateJobTitleShiftAllocationTimes = (shift, jobTitlesAllocationHoursMap, shiftDay, jobTitlesMap) => {
            const mergedUnpaidBreaks = calculateShiftMergedUnpaidBreaks(shift);

            jobTitlesAllocationHoursMap[shiftDay] ??= {
                [LABOR_ALLOCATION_MODE.FLOOR]: 0,
                [LABOR_ALLOCATION_MODE.FIXED]: 0,
                [LABOR_ALLOCATION_MODE.VARIABLE]: 0,
            };
            jobTitlesAllocationHoursMap.TOTALS ??= {
                [LABOR_ALLOCATION_MODE.FLOOR]: 0,
                [LABOR_ALLOCATION_MODE.FIXED]: 0,
                [LABOR_ALLOCATION_MODE.VARIABLE]: 0,
            };

            for (const jobTitle of (shift.job_titles ?? [])) {
                if (jobTitle.start_time && jobTitle.end_time) {
                    const time = calculateJobTitleTimeWithBreaks(shift, jobTitle, mergedUnpaidBreaks, shiftDay);
                    const jobTitleDetails = jobTitlesMap?.[jobTitle.job_title_id] ?? {};

                    jobTitlesAllocationHoursMap[shiftDay][jobTitleDetails.labor_allocation_mode] += time;
                    jobTitlesAllocationHoursMap.TOTALS[jobTitleDetails.labor_allocation_mode] += time;
                }
            }

            return jobTitlesAllocationHoursMap;
        }

	    self.makeCalculations = function (dontNotify) {

		    if (self.flatData['costs']) {

			    // reset USERS' data when recalculating costs
                self.daysFormat = {};
			    self.userWeeklyHoursMap = {};
			    self.userWeeklyScheduledHoursMap = {};
			    self.userNetWeeklyHoursMap = {};
			    self.userWeeklyOTHoursMap = {};
			    self.userWeeklyDoubleOTHoursMap = {};
			    self.jobTitlesAllocationHoursMap = {};
			    self.userDailyHoursMap = {};
			    self.userDailyOTHoursMap = {};
			    self.userDailyDoubleOTHoursMap = {};
			    self.userNetDailyHoursMap = {};
			    self.userDailySpreadHours = {};
			    self.userConsecutiveHoursMap = {};
                self.userWeeklyBlendedFinancialMap = {};
                self.userCostPerDayMap = {};
                self.userHoursPerDayMap = {};
                self.userHoursPerCategoryMap = {};
                self.paytypeCategories = {};
                self.paytypePositions = {};
                self.salariedUserShiftsLocations = {};
                self.previousWeekShifts = [];
                self.ready = {};
                self.userOptInWorkLimitHoursMap = {};
                self.sortedShiftsPerUserPerBusinessDayMap = {};
                self.reportingTimeShiftsMap = {};

                // These are for the UK overtime
                self.userScheduledShifts = {};
                self.userScheduledHours = {};
                var userScheduledShifts = {};
                var userScheduledHours = {};

                //CA split shift premiums
                self.userPrimaryLocationWorkingMap = {};
                var isOvernightShiftSettingsEnabled = scheduleDataServiceV2.checkOvernightShiftsSettings(scheduleDataServiceV2.startDate);

                var calculatedFields = [
                    'net_time',
                    'daily_overtime',
                    'daily_double_overtime',
                    'weekly_overtime',
                    'weekly_double_overtime',
                    'guest_weekly_overtime'
                ];

                if (philippinesPremiumsTypes.length) {
                    self.userRestDayMap = parsePreviousWeekWorkedDays(workedDaysData);
                }
                self.unassignedShiftsMap = {
                    total_unassigned_shifts_count: 0,
                    total_unassigned_shifts_seconds: 0,
                    total_extra_pay: 0,
                    positions: {}
                }

                if (
                    philippinesPremiumsTypes.indexOf('REGULAR_HOLIDAY') > -1 ||
                    philippinesPremiumsTypes.indexOf('SPECIAL_NON_WORKING_DAY') > -1
                 ) {
                    calculatedFields.push('next_day_overtime', 'next_day_net_time');
                }

                for (var userId in self.flatData['costs']){
                    var userCost = self.flatData['costs'][userId] || {};

                    for (var field in calculatedFields) {
                        delete userCost['exceeded_' + calculatedFields[field]];
                    }

                    delete userCost['exceeded_weekly_consecutive_overtime'];
                    delete userCost['ph_rest_day'];
                    delete userCost['exceeded_weekly_consecutive_double_overtime'];
                }

			    var allShifts = [];
			    // get all shifts from same location
			    for (var shiftId in scheduleDataServiceV2.flatData['shifts']) {
			    	allShifts.push(scheduleDataServiceV2.flatData['shifts'][shiftId]);
				}
                //get extended shifts
                if (isOvernightShiftSettingsEnabled) {
                    for (var id in scheduleDataServiceV2.flatData['extended_shifts']) {
                        allShifts.push(scheduleDataServiceV2.flatData['extended_shifts'][id]);
                    }

                    for (var id in scheduleDataServiceV2.extraDayFlatData['extended_shifts']) {
                        allShifts.push(scheduleDataServiceV2.extraDayFlatData['extended_shifts'][id]);
                    }
                }
				// get all cross location shifts
			    for (var brand in scheduleDataServiceV2.crossFlatData) {
			    	for (var ext in scheduleDataServiceV2.crossFlatData[brand]['shifts']) {
			    		allShifts.push(scheduleDataServiceV2.crossFlatData[brand]['shifts'][ext]);
					}

			    	if (isOvernightShiftSettingsEnabled && scheduleDataServiceV2.crossFlatData[brand]['extended_shifts']) {
                        for (var e in scheduleDataServiceV2.crossFlatData[brand]['extended_shifts']) {
                            allShifts.push(scheduleDataServiceV2.crossFlatData[brand]['extended_shifts'][e]);
                        }
                    }
				}
                //get previous week cross locations extended shifts
                if (isOvernightShiftSettingsEnabled) {
                    for (var brand in scheduleDataServiceV2.extraCrossDayFlatData['brands']) {
                        for (var ext in scheduleDataServiceV2.extraCrossDayFlatData['brands'][brand]['extended_shifts']) {
                            allShifts.push(scheduleDataServiceV2.extraCrossDayFlatData['brands'][brand]['extended_shifts'][ext]);
                        }
                    }
                }

			    var sortedShifts = _.sortBy(allShifts, function (shift) {
				    if (shift) {
                        var position_code = shift.position.code;

                        if (self.isGuestOTEnabled) {
                            return !isShiftOnPrimaryLocation(shift) + "_" + new Date(shift.start_time).getTime() + "_" + new Date(shift.end_time).getTime() + "_" + position_code;
                        } else {
                            return new Date(shift.start_time).getTime() + "_" + new Date(shift.end_time).getTime() + "_" + position_code;
                        }
				    }
			    });

                var isNevada24HoursEnabledForFirstDay = (
                    self.maxDailyMap[scheduleDataServiceV2.startDate] &&
                    self.maxDailyMap[scheduleDataServiceV2.startDate]["type"] === "NEVADA_DAILY" &&
                    self.maxDailyMap[scheduleDataServiceV2.startDate]["extraction_period_type"] === "24_HOURS"
                );

                if (self.isSpreadOfHoursV2Enabled(scheduleDataServiceV2.startDate)) {
                    checkSohOnExtraDay();
                }

                if (isNevada24HoursEnabledForFirstDay) {
                    var previousWeekShifts = getPreviousWeekShifts(angular.copy(scheduleDataServiceV2.extraScheduleDay), angular.copy(scheduleDataServiceV2.extraCrossDay));
                    self.previousWeekShifts = _.sortBy(previousWeekShifts, function (previousShift) {
                        if (previousShift) {
                            var position_code = previousShift.position.code;
                            return new Date(previousShift.start_time).getTime() + "_" + new Date(previousShift.end_time).getTime() + "_" + position_code;
                        }
                    });

                    calculateOTForDayBefore(self.previousWeekShifts);
                }

			    for (var i in sortedShifts) {
				    var shift = sortedShifts[i];

				    if (shift) {
					    var shiftPosition = shift['position'];
					    var userId = shift['user_id'];
					    var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

					    if (!filterByUserId || userId === filterByUserId) {
						    var keys = ['period'];

                            let start = _scheduleDateUtilsService.moment(shift.start_time).valueOf();
                            let end = _scheduleDateUtilsService.moment(shift.end_time).valueOf();
                            const shiftStart = start;
                            const shiftEnd = end;

                            shift.length = (end - start) / MILLISECOND;

                            if (isOvernightShiftSettingsEnabled) {
                                var closeTimeObject = shiftTemplateUtils.secondsToTimeObj(scheduleDataServiceV2.dayCloseHour / MILLISECOND);
                                var shiftEdgeTime = _scheduleDateUtilsService.moment(shift.day).clone().hours(closeTimeObject.hours).minutes(closeTimeObject.minutes);

                                if (shift['isExtendedOverNextDay']) {
                                    end = shiftEdgeTime.valueOf();
                                } else if (shift['isExtendedFromPreviousDay']) {
                                    start = shiftEdgeTime.valueOf();
                                }
                            }

                            shift.calculatedStart = start;
                            shift.calculatedEnd = end;
                            shift.period = (end - start) / MILLISECOND / HOUR;
						    // shift costInfo Object to contain all COSTS details
						    shift.costInfo = {
                                // shift time that is calculated for cost in seconds
                                time: (end - start) / MILLISECOND,
                                over_times: {},
                                diff_rules: [],
                                spread_of_hours_cost: 0,
                                net_time: 0,
                                daily_overtime: 0,
                                daily_double_overtime: 0,
                                weekly_overtime: 0,
                                weekly_double_overtime: 0,
                                cost: 0,
                                bonus: 0,
                                full_cost: 0,
                                salaried: undefined,
                                extra_pay: 0
                            };

                            if (philippinesPremiumsTypes.indexOf('REGULAR_HOLIDAY') > -1 ||
                                philippinesPremiumsTypes.indexOf('SPECIAL_NON_WORKING_DAY') > -1) {
                                shift.costInfo['next_day_overtime'] = 0;
                                shift.costInfo['next_day_net_time'] = 0;
                            }

                            if (!activeBreaksMode) {
                                console.error("activeBreaksMode is:", activeBreaksMode);
                            }

                            if (activeBreaksMode === self.BREAKS_ENGINES.DYNAMIC) {
                                subtractDynamicUnpaidBreaks(shift, shiftDay);
                            }
                            else if (activeBreaksMode === self.BREAKS_ENGINES.STATIC) {
                                subtractStaticShiftBreaksSplits(shift);
                            }
                            // ELSE
                            // BREAKS_ENGINE is of type NONE and thus we do nothing

                            if (scheduleDataServiceV2.isMcDLaborServiceEnabled) {
                                self.jobTitlesAllocationHoursMap = calculateJobTitleShiftAllocationTimes(shift, self.jobTitlesAllocationHoursMap, shiftDay, scheduleDataServiceV2.brandJobTiles);
                            }

						    if (shift.period < 0) {
							    console.warn("-----------------");
							    console.warn("Shift has negative period:", shift);
							    console.warn("start:", new Date(start));
							    console.warn("end:", new Date(end));
						    }

                            shift.period = calculateShiftPeriod(shift);

						    if (shift.user_id && shift.status !== 'DELETED') {
							    var userCosts = self.flatData['costs'][shift.user_id] || {};

							    self.userWeeklyHoursMap[shift.user_id] = self.userWeeklyHoursMap[shift.user_id] || 0;
							    self.userWeeklyScheduledHoursMap[shift.user_id] = self.userWeeklyScheduledHoursMap[shift.user_id] || 0;
							    self.userNetWeeklyHoursMap[shift.user_id] = self.userNetWeeklyHoursMap[shift.user_id] || 0;
							    self.userWeeklyOTHoursMap[shift.user_id] = self.userWeeklyOTHoursMap[shift.user_id] || 0;
							    self.userWeeklyDoubleOTHoursMap[shift.user_id] = self.userWeeklyDoubleOTHoursMap[shift.user_id] || 0;

                                self.userWeeklyBlendedFinancialMap[shift.user_id] ??= {straight_time_cost: 0, differential_pay: 0, stations_extra_pay: 0, total_hours: 0};

                                self.userDailyHoursMap[shift.user_id] = self.userDailyHoursMap[shift.user_id] || {};
                                self.userDailyHoursMap[shift.user_id][shiftDay] = self.userDailyHoursMap[shift.user_id][shiftDay] || {
                                    length: 0,
                                    period: 0,
                                    time: 0,
                                };

							    self.userDailyOTHoursMap[shift.user_id] = self.userDailyOTHoursMap[shift.user_id] || {};
							    self.userDailyOTHoursMap[shift.user_id][shiftDay] = self.userDailyOTHoursMap[shift.user_id][shiftDay] || 0;

							    self.userDailyDoubleOTHoursMap[shift.user_id] = self.userDailyDoubleOTHoursMap[shift.user_id] || {};
							    self.userDailyDoubleOTHoursMap[shift.user_id][shiftDay] = self.userDailyDoubleOTHoursMap[shift.user_id][shiftDay] || 0;

							    self.userNetDailyHoursMap[shift.user_id] = self.userNetDailyHoursMap[shift.user_id] || {};
							    self.userNetDailyHoursMap[shift.user_id][shiftDay] = self.userNetDailyHoursMap[shift.user_id][shiftDay] || 0;

                                self.userOptInWorkLimitHoursMap[shift.user_id] ??= {hours: 0};

							    // keep track of USER consecutive hours threshold for 7th day
							    if (!self.userConsecutiveHoursMap[shift.user_id]
									    && self.userConsecutiveHoursMap[shift.user_id] !== 0)
							    {
								    self.userConsecutiveHoursMap[shift.user_id] =
										    (self.consecutiveDayMap[shiftDay]
										        && self.consecutiveDayMap[shiftDay]["dot_threshold"])
										    || 100;
							    }

                                const shiftStartDate = new Date(shiftStart).toDateString();
                                self.daysFormat = addShiftDayToDaysMap(self.daysFormat, shiftStartDate, new Date(shiftDay).toDateString());

                                // USER Spread of Hours Mapping
                                self.userDailySpreadHours[shift.user_id] ??= {};
                                self.userDailySpreadHours[shift.user_id][self.daysFormat[shiftStartDate].currentDay] ??= {exceeded: false};
                                self.userDailySpreadHours[shift.user_id][self.daysFormat[shiftStartDate].previousDay] ??= {exceeded: false};

                                shift.costInfo.exceeded_spread_of_hours = checkIfShiftExceedSpreadOfHours(shift, shiftDay, shiftDay, self.daysFormat[shiftStartDate], self.spreadOfHoursMap, self.spreadOfHoursModeMap, self.userDailySpreadHours, start, end, shiftStart, shiftEnd);

                                self.userDailyHoursMap[shift.user_id][shiftDay].time += shift.costInfo.time || 0;
                                self.userDailyHoursMap[shift.user_id][shiftDay].length += shift.length || 0;
                                self.userDailyHoursMap[shift.user_id][shiftDay].period += shift.period || 0;
							    self.userWeeklyHoursMap[shift.user_id] += shift.costInfo.time;
							    self.userWeeklyScheduledHoursMap[shift.user_id] += shift.period;

                                if (userCosts.work_limits?.[shiftDay]?.value === WorkLimitResponseValue.IN) {
                                    self.userOptInWorkLimitHoursMap[shift.user_id]["hours"] += shift.costInfo.time / HOUR;
                                }

                                shift.payType = userCosts["pay_type"] && userCosts["pay_type"][shiftDay];

                                var userPayTypeForShiftDay =
                                    (userCosts["pay_type"] && userCosts["pay_type"][shiftDay]
                                        && userCosts["pay_type"][shiftDay]["type"])
                                    || self.PAY_TYPES.NONE;

                                var brandPayTypeTrackMode =
                                    (brandPayTypes &&
                                        userPayTypeForShiftDay &&
                                        brandPayTypes[userPayTypeForShiftDay] &&
                                        brandPayTypes[userPayTypeForShiftDay]['track_mode'])
                                    || "NONE";

                                if (philippinesPremiumsTypes.indexOf('REST_DAY') > -1 && userPayTypeForShiftDay === self.PAY_TYPES.HOURLY) {
                                    self.userRestDayMap[shift.user_id] = self.userRestDayMap[shift.user_id] || prepareUserRestDayMap();
                                    var restDayMap = self.userRestDayMap[shift.user_id];
                                    var days = Object.keys(restDayMap);
                                    var shiftDayIndex = days.findIndex(function (day) {
                                        return day === shiftDay;
                                    });
                                    var previousDay = shiftDayIndex > 0 ? days[shiftDayIndex - 1] : null;
                                    var currentDayHasWorked = restDayMap[shiftDay] && restDayMap[shiftDay]['hasWork'];
                                    var previousDayHasWorked = previousDay && restDayMap[previousDay] && restDayMap[previousDay]['hasWork'];

                                    if (previousDay && !previousDayHasWorked && !currentDayHasWorked) {
                                        restDayMap['worked_days_counter'] = 0;
                                    }

                                    if (!currentDayHasWorked) {
                                        restDayMap['worked_days_counter']++;
                                    }

                                    restDayMap[shiftDay] = restDayMap[shiftDay] || {};
                                    restDayMap[shiftDay]['hasWork'] = true;
                                    restDayMap[shiftDay]['total_hours'] += Utils.roundFloat(shift.costInfo.time / HOUR);

                                    if (restDayMap['worked_days_counter'] === 7) {
                                        userCosts['ph_rest_day'] = true;
                                        userCosts['rest_day'] = shift.day;
                                        shift.costInfo['ph_rest_day'] = true;
                                    }
                                }


                                const daysWorked = Object.keys(self.userDailyHoursMap[shift.user_id]).length;

                                if (isShiftDayThe7thDay(shiftDay, daysWorked, self.endDate)) {
                                    shift.costInfo.net_time = shift.costInfo.time;
                                    if (!self.consecutiveDayMap[shiftDay]?.worked_hours_threshold) {
                                        calculateShiftConsecutiveOT(shift);
                                    }
                                } else if (userPayTypeForShiftDay === self.PAY_TYPES.HOURLY) {
                                    calculateShiftTimes(shift, shiftDay);
                                }

                                var userInfo = tsUsersService.users[shift.user_id] || {};

                                self.paytypeCategories[userPayTypeForShiftDay] = self.paytypeCategories[userPayTypeForShiftDay] || { categories: [] };
                                self.paytypePositions[userPayTypeForShiftDay] = self.paytypePositions[userPayTypeForShiftDay] || { positions: [] };

                                if (self.paytypeCategories[userPayTypeForShiftDay]['categories'].indexOf(shift.position.category.code) === -1) {
                                    self.paytypeCategories[userPayTypeForShiftDay]['categories'].push(shift.position.category.code);
                                }

                                if (!shift['cross_location']) {
                                    var positionFound = _.findWhere(self.paytypePositions[userPayTypeForShiftDay]['positions'], {code: shift.position.code});
                                    if (!positionFound) {
                                        self.paytypePositions[userPayTypeForShiftDay]['positions'].push(shift.position);
                                    }
                                }

                                var userAnnualRateForShiftDay =
                                    (userCosts["annual_rate"] && userCosts["annual_rate"][shiftDay]
                                        && userCosts["annual_rate"][shiftDay]["value"])
                                    || 0;

							    var userShiftsPerWeekForShiftDay =
                                    (userCosts["shifts_per_week"] && userCosts["shifts_per_week"][shiftDay]
                                        && userCosts["shifts_per_week"][shiftDay]["value"])
                                    || 0;

							    var userHoursPerWeekForShiftDay =
                                    (userCosts["max_weekly_hours"] && userCosts["max_weekly_hours"][shiftDay]
                                        && userCosts["max_weekly_hours"][shiftDay]["value"])
                                    || 0;

                                var userPayTypeTrackModeForShiftDay;
							    if (userPayTypeForShiftDay === self.PAY_TYPES.SALARIED) {
							        userPayTypeTrackModeForShiftDay = self.PAY_TYPES[self.PAY_TYPES.SALARIED + '_' + brandPayTypeTrackMode];
                                }
                                else {
                                    userPayTypeTrackModeForShiftDay = "NONE";
                                }

                                shift.costInfo.salaried = (userPayTypeForShiftDay === self.PAY_TYPES.SALARIED);

                                if (shift.costInfo.salaried) {
                                    self.salariedUserShiftsLocations[shift.user_id] ??= {days: {}, working_days_count: 0};
                                    if (!self.salariedUserShiftsLocations[shift.user_id].days[shift.day]) {
                                        self.salariedUserShiftsLocations[shift.user_id].days[shift.day] ??= {locations_map: {}, locations_count: 0};
                                        self.salariedUserShiftsLocations[shift.user_id].working_days_count++;
                                    }
                                    if (!self.salariedUserShiftsLocations[shift.user_id].days[shift.day].locations_map[shift.brand_id]) {
                                        self.salariedUserShiftsLocations[shift.user_id].days[shift.day].locations_map[shift.brand_id] = true;
                                        self.salariedUserShiftsLocations[shift.user_id].days[shift.day].locations_count++;
                                    }
                                }

                                if (!shift['cross_location']) {
                                    calculateUserDailyHours(shift.user_id, shiftDay, userPayTypeForShiftDay, shift.period, shift.position);
                                    calculateUserDailyHoursPerCategory(shift);
                                }

                                if (userPayTypeForShiftDay === self.PAY_TYPES.HOURLY) {
                                    shift.costInfo.allow_access =
                                        userCosts[shiftPosition.code] &&
                                        userCosts[shiftPosition.code]['allow_access'];

                                    if (isExtraPayEnabled(scheduleDataServiceV2.getExtraPaySettings(), shiftDay)) {
                                        let extraPays = calculateExtraJobStations(shift, userId, shiftDay);
                                        for (const extraPay of extraPays) {
                                            const stationsExtraPay = extraPay.rate * extraPay.period;
                                            shift.costInfo['extra_pay'] += stationsExtraPay;
                                            shift.costInfo.cost += stationsExtraPay;

                                            if (shift.costInfo.allow_access) {
                                                self.userWeeklyBlendedFinancialMap[shift.user_id].stations_extra_pay += stationsExtraPay;
                                            }
                                        }
                                    }
                                } else {
                                    shift.costInfo.allow_access =
                                        (userCosts["annual_rate"] &&
                                            userCosts["annual_rate"][shiftDay]
                                            && userCosts["annual_rate"][shiftDay]["allow_access"]);
                                }

                                var teamLiveCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
                                var isPhilippineRestDay = shift.day == userCosts['rest_day'];
                                var rateFactorDetails = getRateFactor(shift.day, teamLiveCountryCode, isPhilippineRestDay);
                                var rateFactor = rateFactorDetails['rate'];
                                var dailyOvertimeRate = rateFactorDetails['overtimeRate'];

                                if ( philippinesPremiumsTypes.indexOf('REGULAR_HOLIDAY') > -1 ||
                                    philippinesPremiumsTypes.indexOf('SPECIAL_NON_WORKING_DAY') > -1) {
                                    var nextDayRateFactorDetails = getRateFactor(shift.nextDay, teamLiveCountryCode, isPhilippineRestDay);
                                    var nextDayRateFactor = nextDayRateFactorDetails['rate'];
                                    var nextDayDailyOvertimeRate = nextDayRateFactorDetails['overtimeRate'];
                                }

                                shift.costInfo['ot_daily_rate'] = (
                                    nextDayRateFactorDetails && nextDayRateFactorDetails['overtimeFactor'] ||
                                    rateFactorDetails['overtimeFactor']
                                );

                                shift.initialCostInfo = angular.copy(shift.costInfo);

                                if (
                                    !shift.costInfo.allow_access &&
                                    !isViewFullLaborAndWagePercentagesEnabled
                                ) {
                                    continue;
                                }

                                if (shift.costInfo?.has_meal_break_deduction) {
                                    shift.costInfo.cost -= shift.costInfo.meal_value;
                                }

                                var appliedUKOvertime = ['UK', 'DK'].indexOf(teamLiveCountryCode) > -1;
                                var ukDkOvertimeEnabled = appliedUKOvertime && self.otEnabled && self.otEnabled[userPayTypeForShiftDay];
                                var annualSalary = userAnnualRateForShiftDay / 100;
                                var shiftWeight = shift.weight;
                                var shiftPeriod = shift.costInfo.time / HOUR;
                                self.userScheduledShifts[shift.user_id] = self.userScheduledShifts[shift.user_id] || 0;
                                self.userScheduledHours[shift.user_id] = self.userScheduledHours[shift.user_id] || 0;

                                userScheduledShifts[shift.user_id] = userScheduledShifts[shift.user_id] || 0;
                                userScheduledHours[shift.user_id] = userScheduledHours[shift.user_id] || 0;

                                if (shift.costInfo.allow_access) {
                                    self.userScheduledHours[shift.user_id] += shiftPeriod;

                                    if (!shift.isExtendedFromPreviousDay) {
                                        self.userScheduledShifts[shift.user_id] += shiftWeight;
                                    }
                                }

                                userScheduledHours[shift.user_id] += shiftPeriod;

                                if (!shift.isExtendedFromPreviousDay) {
                                    userScheduledShifts[shift.user_id] += shiftWeight;
                                }

                                /* If Type == SALARIED or WEIGHTED_SHIFT - use ANNUAL_RATE */
                                /* If WEIGHTED_SHIFT then divide annual rate by WEEKS_PER_YEAR weeks and then by user contracted shifts per week */
                                var ukDkOvertimePayTypes = [self.PAY_TYPES.WEIGHTED_SHIFT, self.PAY_TYPES.SALARIED];
                                if (
                                    !shift['isExtendedFromPreviousDay'] &&
                                    (
                                        userPayTypeForShiftDay === self.PAY_TYPES.WEIGHTED_SHIFT ||
                                        (ukDkOvertimePayTypes.indexOf(userPayTypeForShiftDay) && ukDkOvertimeEnabled)
                                    )
                                ) {
                                    var userPayPerHour = 0;
                                    var userPayPerShift = 0;

                                    if (userHoursPerWeekForShiftDay && annualSalary) {
                                        userPayPerHour = Math.round((annualSalary / WEEKS_PER_YEAR / userHoursPerWeekForShiftDay) * 100) / 100;
                                    }

                                    if (userShiftsPerWeekForShiftDay && annualSalary) {
                                        userPayPerShift = Math.round((annualSalary / WEEKS_PER_YEAR / userShiftsPerWeekForShiftDay) * 100) / 100;
                                    }

                                    if (userPayTypeForShiftDay === self.PAY_TYPES.WEIGHTED_SHIFT ||
                                        (userPayTypeForShiftDay === self.PAY_TYPES.SALARIED &&
                                            brandPayTypeTrackMode === self.PAY_TYPES.WEIGHTED_SHIFT)
                                    ) {
                                        var weeklyShifts = userScheduledShifts[shift.user_id];
                                        var overWeeklyShifts = weeklyShifts > userShiftsPerWeekForShiftDay;

                                        if (userPayPerShift &&
                                            ((!self.otEnabled || !self.otEnabled[userPayTypeForShiftDay]) ||
                                                (self.otEnabled[userPayTypeForShiftDay] && !overWeeklyShifts))
                                        ) {
                                            shift.costInfo.cost = shiftWeight * userPayPerShift;
                                        }

                                        if (
                                            userPayPerShift &&
                                            self.otEnabled &&
                                            self.otEnabled[userPayTypeForShiftDay] &&
                                            overWeeklyShifts
                                        ) {
                                            shift.costInfo.overtimeEligible = true;

                                            var trackOT = self.otType[userPayTypeForShiftDay];

                                            if (trackOT === 'HOUR') {

                                                var overtimeShifts, regularShifts, OTHourSInShift, hoursPerShiftWeight;

                                                if (weeklyShifts - userShiftsPerWeekForShiftDay > shiftWeight) {
                                                    overtimeShifts = shiftWeight;
                                                } else {
                                                    overtimeShifts = weeklyShifts - userShiftsPerWeekForShiftDay;
                                                }

                                                regularShifts = shiftWeight - overtimeShifts;
                                                if (shiftWeight > 1 || weeklyShifts - userShiftsPerWeekForShiftDay > 0) {
                                                    hoursPerShiftWeight = shiftPeriod / shiftWeight;
                                                    OTHourSInShift  = overtimeShifts * hoursPerShiftWeight
                                                } else {
                                                    OTHourSInShift = shiftPeriod;
                                                }

                                                shift.costInfo.overtimeCost = overtimeShifts > 0 ? OTHourSInShift * userPayPerHour : 0;
                                                shift.costInfo.overtimeHours = OTHourSInShift * HOUR;
                                                shift.costInfo.time -= shift.costInfo.overtimeHours;

                                                shift.costInfo.cost = (regularShifts * userPayPerShift) + shift.costInfo.overtimeCost;
                                            } else if (trackOT === 'SHIFT') {

                                                var overtimeShifts, regularShifts, OTHourSInShift, hoursPerShiftWeight;

                                                if (weeklyShifts - userShiftsPerWeekForShiftDay > shiftWeight) {
                                                    overtimeShifts = shiftWeight;
                                                } else {
                                                    overtimeShifts = weeklyShifts - userShiftsPerWeekForShiftDay;
                                                }

                                                regularShifts = shiftWeight - overtimeShifts;
                                                if (shiftWeight > 1 || weeklyShifts - userShiftsPerWeekForShiftDay > 0) {
                                                    hoursPerShiftWeight = shiftPeriod / shiftWeight;
                                                    OTHourSInShift  = overtimeShifts * hoursPerShiftWeight
                                                } else {
                                                    OTHourSInShift = shiftPeriod;
                                                }

                                                shift.costInfo.overtimeCost = overtimeShifts * userPayPerShift;
                                                shift.costInfo.overtimeHours = OTHourSInShift * HOUR;
                                                shift.costInfo.time -= shift.costInfo.overtimeHours;

                                                shift.costInfo.cost = (regularShifts * userPayPerShift) + shift.costInfo.overtimeCost;
                                            }
                                        }
                                        const dontAddToTotal = userPayTypeForShiftDay !== self.PAY_TYPES.SALARIED;
                                        const shiftPosition = userPayTypeForShiftDay !== self.PAY_TYPES.SALARIED ? shift.position : {};
                                        if (!shift.cross_location) {
                                            addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', shift.costInfo.overtimeCost, dontAddToTotal, shiftPosition, shift.costInfo.allow_access);
                                        }
                                    } else if (
                                        userPayTypeForShiftDay === self.PAY_TYPES.SALARIED &&
                                        brandPayTypeTrackMode === self.PAY_TYPES.HOURLY
                                    ) {
                                        var weeklyHours = userScheduledHours[shift.user_id];
                                        var overWeeklyHours = weeklyHours > userHoursPerWeekForShiftDay;

                                        if (
                                            userPayPerHour &&
                                            self.otEnabled &&
                                            self.otEnabled[self.PAY_TYPES.SALARIED] &&
                                            overWeeklyHours
                                        ) {
                                            shift.costInfo.overtimeEligible = true;

                                            var overtimeHours2;

                                            if (weeklyHours - userHoursPerWeekForShiftDay > shiftPeriod) {
                                                overtimeHours2 = shiftPeriod;
                                            } else {
                                                overtimeHours2 = weeklyHours - userHoursPerWeekForShiftDay;
                                            }

                                            shift.costInfo.overtimeCost = overtimeHours2 * userPayPerHour;
                                            shift.costInfo.overtimeHours = overtimeHours2 * HOUR;
                                            shift.costInfo.time -= shift.costInfo.overtimeHours;
                                            if (!shift.cross_location) {
                                                addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', shift.costInfo.overtimeCost, false, {}, shift.costInfo.allow_access);
                                            }
                                        }
                                    }
                                }


                                if (userPayTypeForShiftDay === self.PAY_TYPES.SALARIED && isTCGCustomSalariedOTEnabled()) {
                                    if (shift.job_titles && shift.job_titles.length) {
                                        for (var i in shift.job_titles) {
                                            var shiftJobTitle = shift.job_titles[i];

                                            if (shiftJobTitle.start_time && shiftJobTitle.end_time) {
                                                var period = calculateJobTitlePeriod(shiftJobTitle);
                                                var jobTitleInfo = scheduleDataServiceV2.brandJobTiles[shiftJobTitle.job_title_id];
                                                var TCGSalariedOTValue = (jobTitleInfo && (self.TCG_CUSTOME_SALARIED_OT[jobTitleInfo.name] * period)) || 0;
                                                if (!shift.cross_location) {
                                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'TCG_SALARIED_OT', TCGSalariedOTValue, false, shift.position, shift.costInfo.allow_access);
                                                }
                                            }
                                        }
                                    }
                                }

							    if (userPayTypeForShiftDay === self.PAY_TYPES.HOURLY) {

                                    /* All Calculations below for HOURLY type */

                                    var userPositionCosts = (userCosts
                                        && userCosts[shiftPosition.code]
                                        && userCosts[shiftPosition.code][shiftDay]);

                                    if (!userPositionCosts) {
                                        userPositionCosts = (
                                            positionsWithNoAccessPayRateMap[shift.user_id]
                                            && positionsWithNoAccessPayRateMap[userId][shiftPosition.code]
                                            && positionsWithNoAccessPayRateMap[userId][shiftPosition.code][shiftDay]
                                        );
                                    }

                                    var hour_cost = parseFloat((userPositionCosts && userPositionCosts.rate) || 0);

                                    var is_tipped = (userPositionCosts && userPositionCosts.is_tipped);

                                    var minimumWage = userPositionCosts && userPositionCosts.minimum_wage;

                                    var min_wage_cents = (minimumWage
                                        && minimumWage[0]
                                        && minimumWage[0].value);
                                    var min_wage_dollars = min_wage_cents / 100;

                                    for (var field in calculatedFields) {

                                        if (shift.costInfo[calculatedFields[field]]) {

                                            // OT & DOT are paid in minimum wage if employee is tipped
                                            var hourCostOrMinWage = (is_tipped && (hour_cost < min_wage_dollars)) ? min_wage_dollars : hour_cost;
                                            const hoursWorked = shift.costInfo[calculatedFields[field]] / HOUR;

                                            switch (calculatedFields[field]) {
                                                case 'net_time':
                                                    [shift, self.userWeeklyBlendedFinancialMap] = addToShiftCost(shift, hoursWorked, hour_cost, rateFactor, self.userWeeklyBlendedFinancialMap);
                                                    break;

                                                case 'daily_overtime':
                                                    const OT_Value = (shift.costInfo[calculatedFields[field]] / HOUR) * hour_cost * rateFactor;
                                                    [shift, self.userWeeklyBlendedFinancialMap] = addToShiftCost(shift, hoursWorked, hour_cost, rateFactor, self.userWeeklyBlendedFinancialMap);
                                                    if (!shift.cross_location) {
                                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', OT_Value, true, shift.position, shift.costInfo.allow_access, true);
                                                    }
                                                    break;
                                                case 'guest_weekly_overtime':
                                                    const guest_ot_value = (shift.costInfo[calculatedFields[field]] / HOUR) * hour_cost * rateFactor;
                                                    [shift, self.userWeeklyBlendedFinancialMap] = addToShiftCost(shift, hoursWorked, hour_cost, 1, self.userWeeklyBlendedFinancialMap);

                                                    if (!shift.cross_location) {
                                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', guest_ot_value, true, shift.position, shift.costInfo.allow_access, true);
                                                    }
                                                    break;
                                                case 'daily_double_overtime':
                                                    // in daily, (shift_time) excludes daily overtime hours
                                                    const DOT_Value = (shift.costInfo[calculatedFields[field]] / HOUR) * hour_cost * rateFactor;
                                                    [shift, self.userWeeklyBlendedFinancialMap] = addToShiftCost(shift, hoursWorked, hour_cost, 1, self.userWeeklyBlendedFinancialMap);
                                                    if (!shift.cross_location) {
                                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'DOUBLE_OVERTIME', DOT_Value, true, shift.position, shift.costInfo.allow_access, true);
                                                    }
                                                    break;
                                                case 'next_day_net_time':
                                                    //PH brands net time.
                                                    shift.costInfo.cost += (shift.costInfo[calculatedFields[field]] / HOUR) * hour_cost * nextDayRateFactor;
                                                    break;

                                                case 'next_day_overtime':
                                                    //PH brands OT, blended rate is not applied to this type.
                                                    const nextDayCost = (shift.costInfo[calculatedFields[field]] / HOUR) * hour_cost * nextDayRateFactor;
                                                    const nextDayOvertimeCost = (shift.costInfo[calculatedFields[field]] / HOUR * hourCostOrMinWage) * nextDayDailyOvertimeRate;
                                                    shift.costInfo.cost += nextDayCost
                                                    shift.costInfo.cost += nextDayOvertimeCost;
                                                    if (!shift.cross_location) {
                                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', nextDayCost + nextDayOvertimeCost, true, shift.position, shift.costInfo.allow_access, true);
                                                    }
                                                    break;
                                            }

                                            if (shift.costInfo.allow_access && shift.costInfo['exceeded_' + calculatedFields[field]]) {
                                                userCosts['exceeded_' + calculatedFields[field]] = true;
                                            }
                                        }
                                    }

                                    var splitShiftPremiumsRuleForDay = getSplitShiftPremiumsRuleForDay(shiftDay);

                                    if (!shift['cross_location'] && splitShiftPremiumsRuleForDay && splitShiftPremiumsRuleForDay['type'] !== 'NONE') {
                                        self.userPrimaryLocationWorkingMap[shift.user_id] = self.userPrimaryLocationWorkingMap[shift.user_id] || {};
                                        self.userPrimaryLocationWorkingMap[shift.user_id][shift.day] = self.userPrimaryLocationWorkingMap[shift.user_id][shift.day] || {shifts: [], all_shifts: [], type: splitShiftPremiumsRuleForDay['type'], hours: 0, all_hours: 0, positions: {}};
                                        if (shift.costInfo.allow_access) {
                                            self.userPrimaryLocationWorkingMap[shift.user_id][shift.day].hours += shift.costInfo.time;
                                        }
                                        self.userPrimaryLocationWorkingMap[shift.user_id][shift.day].all_hours += shift.costInfo.time;

                                        if (!shift.isExtendedFromPreviousDay) {
                                            if (shift.costInfo.allow_access) {
                                                self.userPrimaryLocationWorkingMap[shift.user_id][shift.day].shifts.push(shift);
                                            }
                                            self.userPrimaryLocationWorkingMap[shift.user_id][shift.day].all_shifts.push(shift);
                                            self.userPrimaryLocationWorkingMap[shift.user_id][shift.day].positions[shiftPosition.code] = {min_wage: min_wage_dollars, hour_rate: hour_cost, threshold: splitShiftPremiumsRuleForDay['threshold']};
                                        }
                                    }

                                    var differentialPayRulesForShift = scheduleDifferentialPayService.getDifferentialPayForShift(shift, hour_cost);
                                    differentialPayRulesForShift = self.getDifferentialPayRulesAccountUnpaidBreaks(shift, differentialPayRulesForShift);
                                    if (!shift['cross_location'] && differentialPayRulesForShift.length) {
                                        applyDifferentialPayRulesOnShift(shift, shiftDay, differentialPayRulesForShift);
                                    }

                                    const incentiveShiftPayment = self.getShiftIncentiveValue(shift, hour_cost);
                                    if (!shift.cross_location && incentiveShiftPayment && shift.costInfo.allow_access) {
                                        shift.cost += incentiveShiftPayment;
                                        shift.costInfo.cost += incentiveShiftPayment;
                                        self.userWeeklyBlendedFinancialMap[shift.user_id].differential_pay += incentiveShiftPayment;
                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'DIFFERENTIAL_PAY', incentiveShiftPayment,true, shift.position, shift.costInfo.allow_access, true);
                                    }
                                }

                                if (shift.costInfo['exceeded_spread_of_hours']) {
                                    var pay_type = self.spreadOfHoursMap[shiftDay]["pay_type"];
                                    // convert min_wage & pay_rate to dollars as they are in cents
                                    var pay_rate = (self.spreadOfHoursMap[shiftDay]["pay_rate"] || 0);
                                    var min_wage = (self.minimumWageMap[shiftDay]
                                        && self.minimumWageMap[shiftDay][0]
                                        && self.minimumWageMap[shiftDay][0]["tier"] == "1"
                                        && self.minimumWageMap[shiftDay][0]["value"] || 0) / 100;
                                    var spreadOfHourCost = 0;

                                    if (pay_type === self.SPREAD_OF_HOURS_TYPES.REGULAR) {
                                        spreadOfHourCost = (hour_cost < min_wage ? min_wage : hour_cost);
                                    }
                                    else if (pay_type === self.SPREAD_OF_HOURS_TYPES.MINIMUM_WAGE) {
                                        spreadOfHourCost = min_wage;
                                    }
                                    else if (pay_type === self.SPREAD_OF_HOURS_TYPES.CUSTOM) {
                                        spreadOfHourCost += pay_rate;
                                    }
                                    else {
                                        console.error("Spread of Hours pay type " + pay_type + " is not supported!");
                                    }
                                    shift.costInfo.spread_of_hours_cost = spreadOfHourCost;
                                    shift.costInfo.cost += spreadOfHourCost;
                                    if (!shift.cross_location) {
                                        addToUserDailyCost(shift.user_id, shift.id, shift.day, 'SPREAD_OF_HOURS', shift.costInfo.spread_of_hours_cost,true, shift.position, shift.costInfo.allow_access, true);
                                    }
                                }

                                if (![self.PAY_TYPES.SALARIED, self.PAY_TYPES.HOURLY].includes(userPayTypeForShiftDay)) {
                                    shift.cost = Math.round(shift.costInfo.cost * 100) / 100;

                                    /**
                                     * Aggregate users costs per days to calculate [VERSIONED] NICs and Pensions
                                     */

                                    if (!shift['cross_location']) {
                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, userPayTypeForShiftDay, shift.cost, false, shift.position, shift.costInfo.allow_access);
                                    }

                                    if (shift['cross_location']) {
                                        addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'CROSS_LOCATION', shift.cost, true, shift.position, shift.costInfo.allow_access);
                                    }

                                    for (var k in keys) {
                                        var key = keys[k];
                                        userCosts[key] = userCosts[key] ? userCosts[key] + shift[key] : shift[key];
                                    }
                                }

                                if (settings['bonus']) {

                                    if (settings['bonus'].length && settings['bonus'][0].payment_types.indexOf(userPayTypeForShiftDay) > -1) {

                                        var applyBonus = getApplyBonusState();
                                        var bonusValue;

                                        if (typeof (applyBonus) == 'undefined' || applyBonus) {

                                            var bonusRateCents = settings['bonus'][0].rate || 0;
                                            var userLeaveDate = tsUsersService.users[shift.user_id] && tsUsersService.users[shift.user_id].leave_date;

                                            if (userPayTypeForShiftDay === self.PAY_TYPES.SALARIED) {
                                                if (!(userLeaveDate && moment(userLeaveDate).isBefore(moment(shiftDay)))) {
                                                    bonusValue = (bonusRateCents * (shift.costInfo.time / HOUR)) / 100;
                                                } else {
                                                    bonusValue = 0;
                                                }
                                            } else {
                                                bonusValue = (bonusRateCents * (shift.costInfo.time / HOUR)) / 100;
                                            }

                                            shift.costInfo.bonus += bonusValue;
                                        } else {
                                            bonusValue = 0;
                                        }

                                        if (!shift['cross_location']) {
                                            const shiftPosition = userPayTypeForShiftDay === self.PAY_TYPES.SALARIED ? {} : shift.position;
                                            addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'BONUS', bonusValue, false, shiftPosition, shift.costInfo.allow_access);
                                        }
                                    }
                                }
						    }
						    else {
                                if (shift.status !== 'DELETED') {
                                    var positionCode = (shift.position && shift.position.code) || 'NO_POSITION';
                                    var positionCategory = (shift.position && shift.position.category) ||  {code: 'NO_CATEGORY'};

                                    self.unassignedShiftsMap.positions[positionCode] = self.unassignedShiftsMap.positions[positionCode] || {
                                        total_unassigned_shifts_count: 0,
                                        total_unassigned_shifts_seconds: 0,
                                        total_extra_pay: 0,
                                        code: positionCode,
                                        category: positionCategory,
                                    };

                                    if (!shift['isExtendedFromPreviousDay']) {
                                        self.unassignedShiftsMap['total_unassigned_shifts_count']++;
                                        self.unassignedShiftsMap.positions[positionCode]['total_unassigned_shifts_count']++;
                                    }

                                    self.unassignedShiftsMap['total_unassigned_shifts_seconds'] += (shift.period * 3600);
                                    self.unassignedShiftsMap.positions[positionCode]['total_unassigned_shifts_seconds'] += (shift.period * 3600);
                                    const incentiveValue = self.getShiftIncentiveValue(shift, 0);
                                    self.unassignedShiftsMap.total_extra_pay += incentiveValue;
                                    self.unassignedShiftsMap.positions[positionCode].total_extra_pay += incentiveValue;

                                    if (settings['schedule'].add_unassigned_shifts_to_totals && !shift['cross_location']) {
                                        calculateUserDailyHours(shift.user_id, shiftDay, null, shift.period, shift.position);
                                        calculateUserDailyHoursPerCategory(shift);
                                    }
                                }
                            }
                            const sortedShiftUserId = shift.user_id ?? "unassigned";
                            self.sortedShiftsPerUserPerBusinessDayMap[shift.day] ??= {};
                            self.sortedShiftsPerUserPerBusinessDayMap[shift.day][sortedShiftUserId] ??= {sortedShifts: []};

                            if (!shift.isExtendedFromPreviousDay) {
                                self.sortedShiftsPerUserPerBusinessDayMap[shift.day][sortedShiftUserId].sortedShifts.push(shift);
                            }
					    }
				    }
			    }

                for (const shift of sortedShifts) {
                    const userId = shift?.['user_id'];
                    if (shift && userId) {
                        const shiftPosition = shift['position'];
                        const shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

                        if (shift.user_id && shift.status !== 'DELETED') {
                            const userCosts = self.flatData['costs'][shift.user_id] || {};
                            const userPayTypeForShiftDay = userCosts?.pay_type?.[shiftDay]?.type || self.PAY_TYPES.NONE;
                            let userPositionCosts = userCosts?.[shiftPosition.code]?.[shiftDay];

                            if (!userPositionCosts) {
                                userPositionCosts = positionsWithNoAccessPayRateMap[userId]?.[shiftPosition.code]?.[shiftDay];
                            }
                            const hour_cost = parseFloat(userPositionCosts?.rate || 0);
                            const is_tipped = userPositionCosts?.is_tipped;
                            const minimumWage = userPositionCosts?.minimum_wage;

                            const min_wage_dollars = (minimumWage?.[0]?.value || 0) / 100;
                            const min_wage_tier_2_dollars = prepareTier2WageValue(minimumWage);

                            const daysWorked = Object.keys(self.userDailyHoursMap[shift.user_id]).length;

                            if (isShiftDayThe7thDay(shiftDay, daysWorked, self.endDate) && self.consecutiveDayMap[shiftDay]?.worked_hours_threshold) {
                                if ((self.consecutiveDayMap[shiftDay]?.worked_hours_threshold < self.userScheduledHours[shift.user_id])) {
                                    calculateShiftConsecutiveOT(shift);
                                } else if (userPayTypeForShiftDay === self.PAY_TYPES.HOURLY) {
                                    calculateShiftTimes(shift, shiftDay);
                                }
                            }

                            if (userPayTypeForShiftDay === self.PAY_TYPES.HOURLY) {
                                const blended_rate = self.calculateUserWeeklyBlendedRate(userId);

                                const teamLiveCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
                                const isPhilippineRestDay = shift.day === userCosts['rest_day'];
                                const rateFactorDetails = getRateFactor(shift.day, teamLiveCountryCode, isPhilippineRestDay);
                                const dailyOvertimeRate = rateFactorDetails['overtimeRate'];

                                for (const field in calculatedFields) {

                                    if (shift.costInfo[calculatedFields[field]]) {

                                        let ot_rate = 0;
                                        let overtimeCost = 0;
                                        let effectiveMinimumWage = (userCosts.is_health_insurance_offeree ? min_wage_tier_2_dollars : min_wage_dollars) || 0;
                                        let hourCostOrEffectiveMinWage = 0;

                                        if (is_tipped) {
                                            // OT & DOT are paid in minimum wage if employee is tipped
                                            ot_rate = (hour_cost < min_wage_dollars) ? min_wage_dollars : hour_cost;
                                            hourCostOrEffectiveMinWage = (hour_cost < effectiveMinimumWage) ? effectiveMinimumWage : hour_cost;
                                        } else {
                                            ot_rate = scheduleDataServiceV2.isBlendedRateEnabled ? blended_rate : hour_cost;
                                            hourCostOrEffectiveMinWage = ot_rate;
                                        }

                                        const hoursWorked = shift.costInfo[calculatedFields[field]] / HOUR;

                                        switch (calculatedFields[field]) {
                                            case 'daily_overtime':
                                                // for nevada OT rule, if the employee’s regular pay rate < 1.5x min wage (based on which min wage tier applies)
                                                // he gets 1.5X his regular pay for every hour worked after 8hrs in a 24 hr period.
                                                // else no Daily OT is applied and delete_warning

                                                if (self.maxDailyMap?.[shiftDay]?.type === "NEVADA_DAILY") {
                                                    if (hour_cost < (1.5 * effectiveMinimumWage)) {
                                                        overtimeCost = (hoursWorked * hourCostOrEffectiveMinWage) * 0.5;
                                                        shift.costInfo.cost += overtimeCost;
                                                        shift.costInfo.over_times['daily_overtime'] = shift.costInfo.over_times['daily_overtime'] || {cost: 0};
                                                        shift.costInfo.over_times['daily_overtime'].cost += overtimeCost;
                                                    } else {
                                                        // delete_warning
                                                        delete shift.costInfo['exceeded_' + calculatedFields[field]];
                                                    }
                                                } else {
                                                    overtimeCost = (shift.costInfo[calculatedFields[field]] / HOUR * ot_rate) * dailyOvertimeRate;
                                                    shift.costInfo.cost += overtimeCost;
                                                    shift.costInfo.over_times['daily_overtime'] = shift.costInfo.over_times['daily_overtime'] || {cost: 0};
                                                    shift.costInfo.over_times['daily_overtime'].cost += overtimeCost;
                                                }
                                                if (!shift.cross_location) {
                                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', overtimeCost,true, shift.position, shift.costInfo.allow_access, true);
                                                }
                                                break;
                                            case 'weekly_overtime':
                                                // in weekly, (shift_time) already includes weekly overtime hours
                                                // in daily, (shift_time) excludes daily overtime hours
                                                // cost is calculated as shift_time * hour_cost && any overtime * 0.5

                                                overtimeCost = (shift.costInfo[calculatedFields[field]] / HOUR * ot_rate) * 0.5;
                                                shift.costInfo.cost += overtimeCost;
                                                shift.costInfo.over_times['weekly_overtime'] = shift.costInfo.over_times['weekly_overtime'] || {cost: 0};
                                                shift.costInfo.over_times['weekly_overtime'].cost += overtimeCost;

                                                const weeklyBasicPay = (shift.costInfo[calculatedFields[field]] / HOUR) * hour_cost;
                                                if (!shift.cross_location) {
                                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', overtimeCost + weeklyBasicPay, true, shift.position, shift.costInfo.allow_access, true);
                                                }
                                                break;

                                            case 'guest_weekly_overtime':
                                                overtimeCost = (shift.costInfo[calculatedFields[field]] / HOUR * ot_rate) * 0.5;
                                                shift.costInfo.cost += overtimeCost;
                                                shift.costInfo.over_times['guest_weekly_overtime'] = shift.costInfo.over_times['guest_weekly_overtime'] || {cost: 0};
                                                shift.costInfo.over_times['guest_weekly_overtime'].cost += overtimeCost;

                                                if (!shift.cross_location) {
                                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'OVERTIME', overtimeCost ,true, shift.position, shift.costInfo.allow_access, true);
                                                }

                                                break;

                                            case 'daily_double_overtime':
                                            case 'weekly_double_overtime':
                                                // in weekly, (shift_time) already includes weekly overtime hours
                                                // in daily, (shift_time) excludes daily overtime hours
                                                // cost is calculated as shift_time * hour_cost && any overtime * 1
                                                overtimeCost = shift.costInfo[calculatedFields[field]] / HOUR * ot_rate;
                                                shift.costInfo.cost += overtimeCost;
                                                shift.costInfo.over_times[calculatedFields[field]] = shift.costInfo.over_times[calculatedFields[field]] || {cost: 0};
                                                shift.costInfo.over_times[calculatedFields[field]].cost += overtimeCost;

                                                if (calculatedFields[field] === 'daily_double_overtime' && !shift.cross_location) {
                                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'DOUBLE_OVERTIME', overtimeCost ,true, shift.position, shift.costInfo.allow_access, true);
                                                }

                                                break;
                                        }
                                    }
                                }
                                shift.cost = Math.round(shift.costInfo.cost * 100) / 100;

                                /**
                                 * Aggregate users costs per days to calculate [VERSIONED] NICs and Pensions
                                 */

                                if (shift['cross_location']) {
                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'CROSS_LOCATION', shift.cost, true, shift.position, shift.costInfo.allow_access);
                                } else {
                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, userPayTypeForShiftDay, shift.cost, false, shift.position, shift.costInfo.allow_access);
                                }

                                for (const key of keys) {
                                    userCosts[key] = userCosts[key] ? userCosts[key] + shift[key] : shift[key];
                                }
                            }
                            let fullCost = shift.costInfo.cost;

                            if (!shift.costInfo.allow_access) {
                                shift.costInfo = shift.initialCostInfo;
                            }
                            shift.costInfo.full_cost = fullCost;
                            shift.initialCostInfo = undefined;

                        }
                    }
                }

                calculateUserSplitShiftsPremium();
                self.reportingTimeShiftsMap = reportingTimeWarningsFactory.prepareReportingTimeShiftsWarnings(
                    self.sortedShiftsPerUserPerBusinessDayMap,
                    settings['schedule'].call_ins,
                    settings['schedule'].call_in_back_to_back_settings
                );
			    if (scheduleDataServiceV2.getJustCauseServiceEnabled()) {
                    JustCauseService.calculateJustCauseWarnings(self.userWeeklyScheduledHoursMap);
                }

                if (
                    philippinesPremiumsTypes.indexOf('REGULAR_HOLIDAY') > -1 ||
                    philippinesPremiumsTypes.indexOf('SPECIAL_NON_WORKING_DAY') > -1
                ) {
                    // calculate the cost for unscheduled users that have been added to the schedule
                    // users that not scheduled on holiday, deserve a premium = rate * previous work form latest worked day
                    for (var day in scheduleDataServiceV2.brandHolidays) {
                        var dayHolidays = scheduleDataServiceV2.brandHolidays[day] || {};
                        var dayData = scheduleDataServiceV2.flatData['days'][day] || {};

                        if (dayData['user_ids'] && dayData['user_ids'].length) {
                            for (var i in dayData['user_ids']) {
                                var userId = dayData['user_ids'][i];
                                var userCostsDetails = self.flatData.costs[userId];

                                if (!userId || !userCostsDetails) {
                                    continue;
                                }

                                var userPrimaryBrand = userCostsDetails['primary_brands'] && userCostsDetails['primary_brands'][day] || {};
                                var userPayType = userCostsDetails['pay_type'] && userCostsDetails['pay_type'][day] || {};
                                var userWork = self.userRestDayMap[userId] || {};
                                var userDayWork = userWork && userWork[day] || {};
                                var isRestDay = isExpectedRestDay(day, userWork);
                                var isRegularHolidayOvertimeEnabled = self.isPhilippinesOverTimeSettingsEnabled('REGULAR_HOLIDAY', day);
                                var isSpecialDayOvertimeEnabled = self.isPhilippinesOverTimeSettingsEnabled('SPECIAL_NON_WORKING_DAY', day);


                                if (userPayType && userPayType['type'] !== self.PAY_TYPES.HOURLY) {
                                    continue;
                                }
                                if (
                                    (isRegularHolidayOvertimeEnabled && dayHolidays['REGULAR_HOLIDAY']) ||
                                    (isSpecialDayOvertimeEnabled && dayHolidays['SPECIAL_NON_WORKING_DAY'] && isRestDay)
                                ) {
                                    if (userPrimaryBrand && !userDayWork['hasWork'] && Object.keys(userWork).length) {
                                        var lastWorkingHours = getUserPreviousWork(day, userWork);
                                        var userInfo = angular.copy(tsUsersService.users[userId]) || {};
                                        userInfo.positions = userInfo.positions || [];
                                        userInfo.positions.sort(function (pos1, pos2) {
                                            return pos1.effective_date > pos2.effective_date? 1: -1;
                                        });
                                        var selectedPosition = userInfo.positions[0];
                                        var userPositionDetails = selectedPosition && userCostsDetails[selectedPosition.code];
                                        var hourCost = parseFloat((userPositionDetails && userPositionDetails[day] && userPositionDetails[day].rate) || 0);

                                        if (lastWorkingHours > 0) {
                                            var holidayPremium = lastWorkingHours * hourCost;
                                            addToUserDailyCost(userCostsDetails.user_id, null, day, self.PAY_TYPES.HOURLY, holidayPremium, false, selectedPosition, true);
                                            addToUserDailyCost(userCostsDetails.user_id, null, day, 'HOLIDAY_PREMIUM', holidayPremium, true, selectedPosition, true);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (brandPayTypes?.[self.PAY_TYPES.SALARIED]) {

                    handleAbsencesForSalariedEmployees();

                    for (const user in self.flatData.costs) {
                        const userCostsDetails = self.flatData.costs[user];

                        for (const day in userCostsDetails.salaried_days) {

                            const salariedDay = userCostsDetails.salaried_days[day];

                            const workingDaysCount = self.salariedUserShiftsLocations[user]?.working_days_count ?? 0;
                            let locationsCount = self.salariedUserShiftsLocations[user]?.days[day]?.locations_count ?? 0;

                            const weeklyPay = userCostsDetails.weekly_salaried_cost ?? 0;

                            let userPayPerDay = settings?.schedule?.include_non_working_days_to_salaried_cost ? salariedDay.cost : (workingDaysCount ? (weeklyPay / workingDaysCount) : 0);

                            if (salariedDay.salaried) {
                                let addSalariedCost = false;
                                let locationCost = 0;
                                const userShiftsIds = scheduleDataServiceV2.flatData?.users?.[user]?.shift_ids || [];
                                const userPrimaryBrand = userCostsDetails.primary_brands?.[day] ?? {};

                                if (
                                    !settings?.schedule?.add_salaried_cost_to_secondary_location_schedule &&
                                    settings?.schedule?.include_non_working_days_to_salaried_cost
                                ) {
                                    locationCost = userPayPerDay;
                                } else if (
                                    settings?.schedule?.add_salaried_cost_to_secondary_location_schedule &&
                                    settings?.schedule?.include_non_working_days_to_salaried_cost
                                ) {
                                    if (self.salariedUserShiftsLocations[user]?.days[day]?.locations_map[scheduleDataServiceV2.brandId]) {
                                        locationCost = locationsCount ? userPayPerDay / locationsCount : 0
                                    } else if (locationsCount === 0 && userPrimaryBrand.brand_id === scheduleDataServiceV2.brandId) {
                                        locationCost = userPayPerDay;
                                    }
                                } else if (
                                    settings?.schedule?.add_salaried_cost_to_secondary_location_schedule &&
                                    !settings?.schedule?.include_non_working_days_to_salaried_cost
                                ) {
                                    locationCost = locationsCount ? userPayPerDay / locationsCount : 0;
                                }

                                if (!settings?.schedule?.include_non_working_days_to_salaried_cost) {
                                    for (const shiftId of userShiftsIds) {
                                        const shift = scheduleDataServiceV2.flatData['shifts'][shiftId];

                                        if (shift?.day === day && shift['status'] !== 'DELETED') {
                                            addSalariedCost = true;
                                            break;
                                        }
                                    }
                                } else if (settings?.schedule?.add_salaried_cost_to_secondary_location_schedule && userPrimaryBrand.brand_id !== scheduleDataServiceV2.brandId) {
                                    for (const shiftId of userShiftsIds) {
                                        const shift = scheduleDataServiceV2.flatData['shifts'][shiftId];

                                        if (shift?.day === day && shift['status'] !== 'DELETED') {
                                            addSalariedCost = true;
                                            break;
                                        }
                                    }
                                } else {
                                    addSalariedCost = true;
                                }

                                if (addSalariedCost) {
                                    addToUserDailyCost(userCostsDetails.user_id, null, day, self.PAY_TYPES.SALARIED, locationCost, false, null, true);
                                }

                                const crossLocationCost = self.salariedUserShiftsLocations[user]?.days[day]?.locations_map[scheduleDataServiceV2.brandId] ? userPayPerDay - locationCost : (locationsCount > 0 ? userPayPerDay : 0);
                                addToUserDailyCost(userCostsDetails.user_id, null, day, 'CROSS_LOCATION', crossLocationCost, false, null, true);
                            }
                        }
                    }
                }

			    self.calculatePeriods();

			    if (!dontNotify) {
                    _emitter.trigger("rates_updated");
			    }
		    }
		    else {
			    console.warn("Costs not ready yet");
		    }

            var breaksMap = activeBreaksMode === self.BREAKS_ENGINES.DYNAMIC ? self.breaksMap : {};
            var brand = teamScheduleService.getBrandById(scheduleDataServiceV2.brandId);

            WorkRestrictionsService.prepareFormattedShiftsMapPerUser(scheduleDataServiceV2.startDate, scheduleDataServiceV2.flatData, scheduleDataServiceV2.crossFlatData, scheduleDataServiceV2.extraDayFlatData, scheduleDataServiceV2.extraCrossDayFlatData, breaksMap);
            WorkRestrictionsService.mapShiftsInLastDayInPreviousWeekForUsers(scheduleDataServiceV2.extraDayFlatData, scheduleDataServiceV2.extraCrossDayFlatData);

            if (brand && brand.is_minor_rules_enabled) {
                MinorSchedulingService.prepareMinorShiftsWarnings(scheduleDataServiceV2.startDate);
            }

            if (self.isWorkRestrictionServiceEnabled) {
                WorkVisasService.prepareWorkVisasShiftsWarnings(scheduleDataServiceV2.startDate);
            }

            setReady('costs');
	    };

        var calculateJobTitlePeriod = function(jobTitle) {
            var start = new Date(jobTitle.start_time).getTime();
            var end = new Date(jobTitle.end_time).getTime();
            var period = (end - start) / MILLISECOND;
            return period / HOUR;
        };


	    var isTCGCustomSalariedOTEnabled = function () {
            var brand = teamScheduleService.getBrandById(scheduleDataServiceV2.brandId);
            var brandIds = [brand.parent_id, scheduleDataServiceV2.brandId];
            var isTcgEnabled = false;

            //first 4 brands is dev brands
            // 5th one for staging sanity
            for (var i in brandIds) {
                isTcgEnabled = [
                    10125341,
                    10146341,
                    10145530,
                    10146342,
                    4070285,
                    4586779,
                    4586811,
                    4586838,
                    4586858,
                    4586897,
                ].indexOf(brandIds[i]) > -1;

                if (isTcgEnabled) {
                    return true;
                }
            }

            return isTcgEnabled;
        };

        /**
         *
         * @param userId {number}
         * @param day {string}
         * @param costType {string}
         * @param [resetConfig={resetDaily: true}] {{resetDaily?: boolean, resetPosition?: boolean, resetShift?: boolean}} to decide on which entry to do the reset
         * @param positionCode {string?} needs to be provided in the case of `resetConfig.resetPosition === true`
         * @param shiftId {number|null?} needs to be provided in the case of `resetConfig.resetShift === true`
         */
        const resetUserCost = (userId, day, costType, resetConfig = {resetDaily: true}, positionCode, shiftId) => {
            if (resetConfig?.resetDaily && self.userCostPerDayMap?.[userId]?.[day]) {
                self.userCostPerDayMap[userId][day][costType] = { cost: 0, full_cost: 0 };
            }

            if (resetConfig?.resetPosition && self.userCostPerDayMap?.[userId]?.[day]?.positions?.[positionCode]) {
                self.userCostPerDayMap[userId][day].positions[positionCode][costType] = { cost: 0, full_cost: 0 };
            }

            if (resetConfig?.resetShift && self.userCostPerDayMap?.[userId]?.[day]?.shifts?.has(shiftId)) {
                const shiftCost = self.userCostPerDayMap[userId][day].shifts.get(shiftId);
                shiftCost.costTypes[costType] = { cost: 0, full_cost: 0 };
            }
        };

	    const addToUserDailyCost = (userId, shiftId, day, costType, value, dontAddToTotal, position, hasPositionAccess, excludeFromTotal) => {
	        costType = costType || "NONE";
            const positionCode = position?.code || 'NO_POSITION';
	        const positionCategory = position?.category || {code: 'NO_CATEGORY'};
            value = isNaN(value) ? 0 : parseFloat(value);
            self.userCostPerDayMap[userId] ??= {};
            self.userCostPerDayMap[userId][day] ??= { total: 0, positions: {}, shifts: new Map()};
            self.userCostPerDayMap[userId][day].positions[positionCode] ??= {code: positionCode, category: positionCategory, total: 0};
            self.userCostPerDayMap[userId][day].positions[positionCode][costType] ??= {cost: 0, full_cost: 0, total: 0};
            self.userCostPerDayMap[userId][day][costType] ??= {cost: 0, full_cost: 0};
            const userShiftCost = self.userCostPerDayMap[userId][day].shifts.get(shiftId) ?? {id: shiftId, position: {code: positionCode, category: positionCategory}, total: 0, costTypes: {}};
            userShiftCost.costTypes[costType] ??= {cost: 0, full_cost: 0};
            if (!dontAddToTotal) {
                self.userCostPerDayMap[userId][day].total += value;
                self.userCostPerDayMap[userId][day].positions[positionCode].total += value;
                userShiftCost.total += value;
            }
            if (hasPositionAccess) {
                self.userCostPerDayMap[userId][day][costType].cost += value;
                self.userCostPerDayMap[userId][day].positions[positionCode][costType].cost += value;
                userShiftCost.costTypes[costType].cost += value;
            }
            if (!excludeFromTotal) {
                self.userCostPerDayMap[userId][day][costType].full_cost += value;
                self.userCostPerDayMap[userId][day].positions[positionCode][costType].full_cost += value;
                userShiftCost.costTypes[costType].full_cost += value;
            }
            if (!self.userCostPerDayMap[userId][day].shifts.has(shiftId)) {
                self.userCostPerDayMap[userId][day].shifts.set(shiftId, userShiftCost);
            }
	    };


	    var calculateUserDailyHours = function (userId, day, payType, value, position) {
            payType = payType || "OTHERS";
            userId = userId || null;
            var positionCode = (position && position.code) || 'NO_POSITION';
            var positionCategory = (position && position.category) ||  {code: 'NO_CATEGORY'};
            value = isNaN(value)? 0: parseFloat(value);
            self.userHoursPerDayMap[userId] = self.userHoursPerDayMap[userId] || {};
            self.userHoursPerDayMap[userId][day] = self.userHoursPerDayMap[userId][day] || {positions: {}};
            self.userHoursPerDayMap[userId][day].positions[positionCode] = self.userHoursPerDayMap[userId][day].positions[positionCode] || {code: positionCode, category: positionCategory, payTypes: {}};
            self.userHoursPerDayMap[userId][day].positions[positionCode].payTypes[payType] = self.userHoursPerDayMap[userId][day].positions[positionCode].payTypes[payType] || 0;
            self.userHoursPerDayMap[userId][day][payType] = self.userHoursPerDayMap[userId][day][payType] || 0;
            self.userHoursPerDayMap[userId][day][payType] += value;
            self.userHoursPerDayMap[userId][day].positions[positionCode].payTypes[payType] += value;
        };

        let calculateUserDailyHoursPerCategory = (shift) => {
            let categoryCode = shift.position.category?.code;
            let categoryName = shift.position.category?.name;
            let value = isNaN(shift.period) ? 0 : parseFloat(shift.period);
            let shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

            self.userHoursPerCategoryMap['week'] = self.userHoursPerCategoryMap['week'] || {};
            self.userHoursPerCategoryMap['week'][categoryCode] ??=  { code: categoryCode, name: categoryName, value: 0 };
            self.userHoursPerCategoryMap['week']['ALL_CATEGORIES'] ??= { code: 'ALL_CATEGORIES', name:  $filter('translate')('All Categories'), value: 0 };

            self.userHoursPerCategoryMap['week'][categoryCode].value += value;
            self.userHoursPerCategoryMap['week']['ALL_CATEGORIES'].value += value;

            self.userHoursPerCategoryMap['days'] = self.userHoursPerCategoryMap['days'] || {};
            self.userHoursPerCategoryMap['days'][shiftDay] = self.userHoursPerCategoryMap['days'][shiftDay] || {};
            self.userHoursPerCategoryMap['days'][shiftDay][categoryCode] ??= { code: categoryCode, name: categoryName, value: 0 };
            self.userHoursPerCategoryMap['days'][shiftDay]['ALL_CATEGORIES'] ??= { code: 'ALL_CATEGORIES', name:  $filter('translate')('All Categories'), value: 0 };
            self.userHoursPerCategoryMap['days'][shiftDay][categoryCode].value += value;
            self.userHoursPerCategoryMap['days'][shiftDay]['ALL_CATEGORIES'].value += value;
        };

	    self.calculateHolidayAccruals = function (cost) {
            cost = cost || 0;
            return (cost * 0.1207);
        };

	    var getSplitShiftPremiumsRuleForDay = function (date) {
	        var splitShiftPremiumsRules = settings['schedule'] && settings['schedule']['split_shift_penalty'] || [];

	        for (var i in splitShiftPremiumsRules) {
                if (new Date(date).getTime() >= new Date(splitShiftPremiumsRules[i].start_date).getTime()) {
                    return splitShiftPremiumsRules[i].type !== 'NONE'? splitShiftPremiumsRules[i] : null;
                }
            }
        };

        self.getShiftIncentiveValue = (shift, hourRate) => {
            let amount = 0;

            for (const incentivePayment of (shift.incentive_payments ?? [])) {
                let ruleHourRate = (incentivePayment.value ?? 0) / 100;

                if (incentivePayment.payment_type === 'PAY_RATE_PERCENTAGE') {
                    ruleHourRate = ((incentivePayment.value ?? 0) / 100) * hourRate;
                }

                amount += ruleHourRate * (shift.costInfo.time / HOUR);
            }

            return amount;
        }

	    const applyDifferentialPayRulesOnShift = (shift, shiftDay, differentialPayRules) => {
            for (let differentialPayRule of differentialPayRules) {
                const payRule = {...differentialPayRule, appliedPeriods: differentialPayRule.appliedPeriods.map((period) => ({...period}))};
                const differentialPayCost = (payRule.seconds / 3600 * payRule.amount);
                payRule.cost = differentialPayCost;
                shift.costInfo.diff_rules.push(payRule);
                shift.cost += differentialPayCost;
                shift.costInfo.cost += differentialPayCost;

                if (shift.costInfo.allow_access) {
                    self.userWeeklyBlendedFinancialMap[shift.user_id].differential_pay += differentialPayCost;
                }
                addToUserDailyCost(shift.user_id, shift.id, shiftDay, 'DIFFERENTIAL_PAY', differentialPayCost,true, shift.position, shift.costInfo.allow_access, true);
            }
        };

        self.getDifferentialPayRulesAccountUnpaidBreaks = function (shift, differentialPayRules) {
            var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];
            var selectedDayOffset = moment(shiftDay).zone(0).valueOf();
            var appliedRules = [];
            for (var r in differentialPayRules) {
                var payRule = differentialPayRules[r];
                var breakDuration = 0;
                for (var i in payRule.appliedPeriods) {
                    var appliedPeriod = payRule.appliedPeriods[i];
                    var differentialPeriodStart = selectedDayOffset + (appliedPeriod.start * MILLISECOND);
                    var differentialPeriodEnd = selectedDayOffset + (appliedPeriod.end * MILLISECOND);
                    for (var j in shift.unpaidBreaks) {
                        var breakItem = shift.unpaidBreaks[j];
                        breakItem = self.setBreakTimeAtShiftEndTimeIfUnscheduled(selectedDayOffset, shift.calculatedEnd, breakItem);
                        breakDuration += getBreakTimeWithinShift(differentialPeriodStart, differentialPeriodEnd, shift.day, breakItem);
                    }
                }
                differentialPayRules[r]['seconds'] -= breakDuration;
                if (differentialPayRules[r]['seconds'] > 0) {
                    appliedRules.push(payRule);
                }
            }

            return appliedRules;
        };

        var calculateUserSplitShiftsPremium = function () {
            for (var i in self.userPrimaryLocationWorkingMap) {
                var userWork = self.userPrimaryLocationWorkingMap[i];

                for (var j in userWork) {
                    var userWorkForDay = userWork[j];
                    var userShifts = userWorkForDay['shifts'];
                    var allUserShifts = userWorkForDay['all_shifts'];

                    if (userShifts && userShifts.length > 1) {
                        var premiumDetailsObj = calculatePremiumCost(userShifts, {
                            positions: userWorkForDay['positions'],
                            type: userWorkForDay['type'],
                            hours: userWorkForDay['hours'],
                        })

                        if (premiumDetailsObj.isSplitShiftRuleApplied) {
                            for (var k = premiumDetailsObj.index; k < userShifts.length; k++) {
                                var shift = userShifts[k];
                                var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];
                                shift.costInfo.split_shift_premium_applied = true;

                                //premium cost on last shift
                                if (k == (userShifts.length - 1)) {
                                    shift.costInfo.split_shift_premium = premiumDetailsObj.premiumCost;
                                    shift.costInfo.cost += premiumDetailsObj.premiumCost;
                                    shift.cost = shift.costInfo.cost;
                                    addToUserDailyCost(shift.user_id, shift.id, shiftDay, "SPLIT_SHIFT_PREMIUM", premiumDetailsObj.premiumCost, false, shift.position, true, true);
                                }
                            }
                        }
                    }

                    if (allUserShifts && allUserShifts.length > 1) {
                        var premiumDetailsObj = calculatePremiumCost(allUserShifts, {
                            positions: userWorkForDay['positions'],
                            type: userWorkForDay['type'],
                            hours: userWorkForDay['all_hours'],
                        })

                        if (premiumDetailsObj.isSplitShiftRuleApplied) {
                            var shift = allUserShifts[allUserShifts.length-1];
                            var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];
                            shift.costInfo.full_cost += premiumDetailsObj.premiumCost;
                            addToUserDailyCost(shift.user_id, shift.id, shiftDay, "SPLIT_SHIFT_PREMIUM", premiumDetailsObj.premiumCost, false, shift.position, false, false);
                        }

                    }
                }
            }
        };

        var calculatePremiumCost = function (userShifts, userWorkForDay) {
            var isSplitShiftRuleApplied = false;
            var premiumCost = 0;
            var index = 0;

            for (var s = 1; s < userShifts.length; s++) {
                var previousShift = userShifts[s - 1];
                var comparedShift = userShifts[s];
                var costInfo = userWorkForDay['positions'][comparedShift.position.code];
                var timeDifference = (new Date(comparedShift.start_time).getTime() - new Date(previousShift.end_time).getTime()) / MILLISECOND;
                var ruleThreshold = costInfo && costInfo['threshold'];

                if (timeDifference > ruleThreshold) {
                    var workingHours = userWorkForDay['hours'] / HOUR;
                    var minWage = costInfo && costInfo['min_wage'];
                    var hourlyRate = costInfo && costInfo['hour_rate'];
                    var isRuleApplicable = userWorkForDay.type === 'DC';

                    if (userWorkForDay.type === 'CA') {
                        isRuleApplicable = minWage * (workingHours + 1) > hourlyRate * workingHours;
                    }
                    if (isRuleApplicable) {
                        isSplitShiftRuleApplied = true;
                        premiumCost = userWorkForDay.type === 'DC' ? minWage : Utils.roundFloat(Math.min(((minWage * (workingHours + 1)) - (hourlyRate * workingHours)), minWage));
                        index = s;
                        break;
                    }
                }
            }

            return {
                isSplitShiftRuleApplied: isSplitShiftRuleApplied,
                premiumCost: premiumCost,
                index: index,
            }
        }

	    self.updateUsersShiftsWeights = function () {

	        for (var i in self.flatData.costs) {
	            var userCosts = self.flatData.costs[i];
	            userCosts["scheduled_shifts"] = 0;

                for (var d in userCosts.pay_type) {
                    var payTypeDay = userCosts.pay_type[d];

                    var isUserPayTypeWeightedShift = payTypeDay["type"] === self.PAY_TYPES.WEIGHTED_SHIFT;

                    if (!isUserPayTypeWeightedShift) {
                        if (payTypeDay["type"] === self.PAY_TYPES.SALARIED && self.getBrandTrackMode() === self.PAY_TYPES.WEIGHTED_SHIFT) {
                            isUserPayTypeWeightedShift = true;
                        }
                    }

                    if (isUserPayTypeWeightedShift) {
                        for (var s in scheduleDataServiceV2.flatData.shifts) {
                            var userShift = scheduleDataServiceV2.flatData.shifts[s];

                            if (userShift.user_id === userCosts.user_id && userShift.day === payTypeDay.date) {
                                if (self.hasWeightedShiftPayType()) {
                                    userCosts["scheduled_shifts"] += userShift.weight || 1;
                                }
                                else {
                                    userCosts["scheduled_shifts"] += 1;
                                }
                            }
                        }
                    }
                }
            }
        };

        const getUserPayTypePerDay = (userId, day) => {
            return self.flatData.costs[userId]?.pay_type[day]?.type;
        };

        /**
         * @param costMap the dictionary of the costs
         * @param payType the user pay-type to retrieve the cost for (this should be the user pay type for the day you want to retrieve).
         * @param countryCode {string} the brand country code.
         * @param costType {'cost'|'full_cost'} to decide from which value to read the cost
         * @returns {number} returns the cost for the entered configuration.
         */
        const calculatePayTypeCost = (costMap, payType, countryCode, costType) => {
            let payTypeCost = costMap?.[payType]?.[costType] || 0;
            if (['UK', 'DK'].includes(countryCode) && payType === self.PAY_TYPES.SALARIED) {
                payTypeCost += costMap?.['OVERTIME']?.[costType] || 0;
            }
            payTypeCost += costMap?.['TCG_SALARIED_OT']?.[costType] || 0;
            payTypeCost += costMap?.['BONUS']?.[costType] || 0;
            payTypeCost += costMap?.['SPLIT_SHIFT_PREMIUM']?.[costType] || 0;

            return payTypeCost;
        };

        const getPayTypeCost = (costMap, userId, day, countryCode) => {
            const payType = getUserPayTypePerDay(userId, day);

            return {
                cost: calculatePayTypeCost(costMap, payType, countryCode, 'cost'),
                full_cost: calculatePayTypeCost(costMap, payType, countryCode, 'full_cost'),
            }
        };

        /**
         * the calculation of pension is done per user per position
         * meaning that if the user had two shifts in the same day
         * and those shifts had different positions then each shift
         * position will have the correct amount of pension added to it.
         */
        self.calculatePensionCosts = () => {
            const brandCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
            for (const userId in self.userCostPerDayMap) {
                const userCost = self.userCostPerDayMap[userId];

                if (!self.flatData.costs[userId]) {
                    continue;
                }

                for (const day in self.flatData.costs[userId]["pension"]) {
                    resetUserCost(userId, day, "PENSION", {resetDaily: true});

                    for (const positionCode in userCost[day]?.positions) {
                        resetUserCost(userId, day, "PENSION", {resetPosition: true}, positionCode);

                        const payTypeDailyCost = getPayTypeCost(userCost?.[day]?.positions[positionCode], userId, day, brandCountryCode);

                        const userPension = self.flatData.costs[userId]?.pension?.[day]?.value || 0;

                        const pensionValue = {cost: 0, full_cost: 0};

                        if (self.flatData.costs[userId].pay_type[day]) {
                            pensionValue.cost = (payTypeDailyCost.cost * (userPension / 100));
                            pensionValue.full_cost = (payTypeDailyCost.full_cost * (userPension / 100));
                        }

                        self.flatData.costs[userId]["pension"][day] ??= {cost: 0, full_cost: 0};

                        self.flatData.costs[userId]["pension"][day].cost += pensionValue.cost;
                        self.flatData.costs[userId]["pension"][day].full_cost += pensionValue.full_cost;

                        const position = (tsUsersService.users[userId].positions || []).find((positionInfo) => positionInfo.code === positionCode);

                        addToUserDailyCost(userId, null, day, "PENSION", pensionValue.full_cost, true, position, false, false);
                        addToUserDailyCost(userId, null, day, "PENSION", pensionValue.cost, true, position, true, true);
                    }
                }
            }

            setReady('pension');
        };

        const calculateAmountToApplyTierOn = (tierInfo, userWeeklyCost, userWeeklyBeforeThisDay) => {
            const tierFromValue = tierInfo.from_value / 100;
            const tierToValue = tierInfo.to_value / 100;

            let startPoint = tierFromValue;
            let endPoint = userWeeklyCost;

            if (tierToValue && userWeeklyCost >= tierToValue) {
                endPoint = tierToValue;
            }

            let shiftedStartPoint = startPoint - userWeeklyBeforeThisDay;
            let shiftedEndPoint = endPoint - userWeeklyBeforeThisDay;
            shiftedStartPoint = (shiftedStartPoint >= 0) ? shiftedStartPoint : 0;
            shiftedEndPoint = (shiftedEndPoint >= 0) ? shiftedEndPoint : 0;

            return shiftedEndPoint - shiftedStartPoint;
        };

        const getNiCost = (userWeeklyCost, userWeeklyBeforeThisDay, niTiers) => {
            const niCost = {cost: 0, full_cost: 0};

            for (const tierInfo of niTiers) {
                const tierFromValue = tierInfo.from_value / 100;
                const tierPercentage = tierInfo.percentage || 0;

                if (userWeeklyCost.cost >= tierFromValue) {
                    const amountToApplyTierOn = calculateAmountToApplyTierOn(tierInfo, userWeeklyCost.cost, userWeeklyBeforeThisDay.cost);
                    niCost.cost += (amountToApplyTierOn * tierPercentage) / 100;
                }

                if (userWeeklyCost.full_cost >= tierFromValue) {
                    const amountToApplyTierOn = calculateAmountToApplyTierOn(tierInfo, userWeeklyCost.full_cost, userWeeklyBeforeThisDay.full_cost);
                    niCost.full_cost += (amountToApplyTierOn * tierPercentage) / 100;
                }
            }

            return niCost;
        };

        /**
         * NI calculation is done by shift for users that are HOURLY and WEIGHTED_SHIFTS,
         * and it is calculated per day for the SALARIED users.
         */
        self.calculateNICosts = () => {
            const brandCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
            for (const userId in self.userCostPerDayMap) {
                const userCost = self.userCostPerDayMap[userId];

                if (!self.flatData.costs[userId]) {
                    continue;
                }

                const userWeeklyCostMap = {};

                for (const day in self.flatData.costs[userId]["ni"]) {
                    resetUserCost(userId, day, "NI", {resetDaily: true});

                    self.flatData.costs[userId]["ni"][day].cost = 0;
                    self.flatData.costs[userId]["ni"][day].full_cost = 0;
                    const userDayPayType = getUserPayTypePerDay(userId, day);

                    if (userDayPayType) {
                        const userWeeklyCost = userWeeklyCostMap[userDayPayType] || {cost: 0, full_cost: 0};
                        const dayNIInfo = self.flatData.costs[userId]["ni"][day] || {};
                        const niTiers = niCategoriesMap[day]?.[dayNIInfo.value];

                        if (niTiers) {
                            if (userDayPayType === self.PAY_TYPES.SALARIED) {
                                const userDailyCost = getPayTypeCost(userCost?.[day]?.positions['NO_POSITION'], userId, day, brandCountryCode);

                                const userWeeklyBeforeThisDay = {...userWeeklyCost};
                                userWeeklyCost.cost += userDailyCost.cost;
                                userWeeklyCost.full_cost += userDailyCost.full_cost;

                                resetUserCost(userId, day, "NI", {resetPosition: true}, 'NO_POSITION');
                                resetUserCost(userId, day, "NI", {resetShift: true}, '', null);

                                const userNICost = getNiCost(userWeeklyCost, userWeeklyBeforeThisDay, niTiers);

                                self.flatData.costs[userId]["ni"][day].cost += userNICost.cost;
                                self.flatData.costs[userId]["ni"][day].full_cost += userNICost.full_cost;

                                addToUserDailyCost(userId, null, day, "NI", userNICost.full_cost, true, null, false, false)
                                addToUserDailyCost(userId, null, day, "NI", userNICost.cost, true, null, true, true)

                                userWeeklyCost.cost += userCost?.[day]?.positions['NO_POSITION']?.['CROSS_LOCATION']?.cost || 0;
                                userWeeklyCost.full_cost += userCost?.[day]?.positions['NO_POSITION']['CROSS_LOCATION']?.full_cost || 0;
                            } else {
                                const shiftsCosts = userCost?.[day]?.shifts ?? [];
                                const resetPositionsMap = {};
                                for (const mapValues of shiftsCosts) {
                                    const shiftCost = mapValues[1]; // getting the value from the tuple.
                                    const shiftTotalCost = getPayTypeCost(shiftCost?.costTypes, userId, day, brandCountryCode);
                                    const userWeeklyBeforeThisDay = {...userWeeklyCost};
                                    userWeeklyCost.cost += shiftTotalCost.cost;
                                    userWeeklyCost.full_cost += shiftTotalCost.full_cost;

                                    if (!resetPositionsMap[shiftCost.position.code]) {
                                        resetUserCost(userId, day, "NI", {resetPosition: true}, shiftCost.position.code);
                                        resetPositionsMap[shiftCost.position.code] = true;
                                    }

                                    resetUserCost(userId, day, "NI", {resetShift: true}, '', shiftCost.id);

                                    const shiftNICost = getNiCost(userWeeklyCost, userWeeklyBeforeThisDay, niTiers);

                                    self.flatData.costs[userId]["ni"][day].cost += shiftNICost.cost;
                                    self.flatData.costs[userId]["ni"][day].full_cost += shiftNICost.full_cost;

                                    addToUserDailyCost(userId, shiftCost.id, day, "NI", shiftNICost.full_cost, true, shiftCost.position, false, false)
                                    addToUserDailyCost(userId, shiftCost.id, day, "NI", shiftNICost.cost, true, shiftCost.position, true, true)

                                    userWeeklyCost.cost += shiftCost?.costTypes?.['CROSS_LOCATION']?.cost || 0;
                                    userWeeklyCost.full_cost += shiftCost?.costTypes?.['CROSS_LOCATION']?.full_cost || 0;
                                }
                            }

                            userWeeklyCostMap[userDayPayType] = userWeeklyCost;
                        } else {
                            console.error('NI tiers not defined');
                        }
                    }
                }
            }

            setReady('ni');
        };

        /**
         * the calculation of Additional cost is done per user per position
         * meaning that if the user had two shifts in the same day
         * and those shifts had different positions then each shift
         * position will have the correct amount of Additional cost added to it.
         */
        self.calculateAdditionalCosts = () => {
            const brandCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
            for (const userId in self.userCostPerDayMap) {
                const userCost = self.userCostPerDayMap[userId];

                if (self.flatData.costs[userId]) {
                    for (const day in self.flatData.costs[userId]["additional_cost"]) {
                        resetUserCost(userId, day, "ADDITIONAL_COST", {resetDaily: true});

                        for (const positionCode in userCost[day]?.positions) {
                            resetUserCost(userId, day, "ADDITIONAL_COST", {resetPosition: true}, positionCode);

                            const payTypeDailyCost = getPayTypeCost(userCost?.[day]?.positions[positionCode], userId, day, brandCountryCode);
                            const userAdditionalCost = self.flatData.costs[userId]?.["additional_cost"]?.[day]?.["value"] || 0;
                            const additionalValue = {cost: 0, full_cost: 0};

                            additionalValue['cost'] = (payTypeDailyCost['cost'] * (userAdditionalCost / 100));
                            additionalValue['full_cost'] = (payTypeDailyCost['full_cost'] * (userAdditionalCost / 100));

                            self.flatData.costs[userId]["additional_cost"][day].cost = additionalValue['cost'];
                            self.flatData.costs[userId]["additional_cost"][day].full_cost = additionalValue['full_cost'];

                            const position = (tsUsersService.users[userId].positions || []).find((positionInfo) => positionInfo.code === positionCode);

                            addToUserDailyCost(userId, null, day, "ADDITIONAL_COST", additionalValue['full_cost'], true, position, false, false);
                            addToUserDailyCost(userId, null, day, "ADDITIONAL_COST", additionalValue['cost'], true, position, true, true);
                        }
                    }
                }
            }

            setReady('additional_cost');
        };

	    self.setBrandBonusSettings = function (bonusSettings) {
	        settings['bonus'] = bonusSettings;
        };

	    self.setBrandScheduleSettings = function (scheduleSettings) {
	        settings['schedule'] = scheduleSettings;
        };

        self.setViewFullLaborAndWagePercentagesPermission = function (isEnabled) {
            isViewFullLaborAndWagePercentagesEnabled = isEnabled;
        }

        self.setWorkRestrictionServiceEnabled = function (isWorkRestrictionServiceEnabled) {
            self.isWorkRestrictionServiceEnabled = isWorkRestrictionServiceEnabled;
        }

        self.getBrandScheduleSettings = function () {
            var defer = $q.defer();
            defer.resolve(angular.copy(settings['schedule']));
            return defer.promise;
        };

        var isCostIncludedInTotal = function (costType, includeTCGCustom) {
            if (costType === "SALARIED") {
                return (
                    settings['schedule'].add_salaried_cost_to_total_cost ||
                    (includeTCGCustom && isTCGCustomSalariedOTEnabled())
                );
            }

            return true;
        };

        self.checkIfUserFound = (userPositions, positionsFilters, categoriesFilters) => {
            if (positionsFilters?.length || categoriesFilters?.length) {
                let found = false;
                for (let position of userPositions) {
                    if (positionsFilters.length && !positionsFilters.includes(position.code)) {
                        continue;
                    }

                    if (categoriesFilters.length && categoriesFilters.indexOf(position.category.code) === -1) {
                        continue;
                    }

                    found = true;
                }
                return found;
            }

            return true;
        }

	    self.getTotalCostsPerPaytype = function (wageAccess, filters) {
            var defer = $q.defer();

            var result = {
                'costs': {},
                'other_costs': {},
                'full_labor_cost': {},
            };

            const isTCGCustomOTEnabled = isTCGCustomSalariedOTEnabled();
            const categoriesCodes = filters?.categories?.map((category) => category.code) ?? [];
            const positionsCodes = filters?.positions?.map((position) => position.code) ?? [];

            for (var userId in self.userCostPerDayMap) {
                var userWeeklyCostMap = self.userCostPerDayMap[userId];
                let userPositions = tsUsersService.users[userId].positions || [];
                let found = self.checkIfUserFound(userPositions, positionsCodes, categoriesCodes);

                if (!found) {
                    continue;
                }

                for (var day in userWeeklyCostMap) {
                    const payType = getUserPayTypePerDay(userId, day);
                    var formattedDay = moment(day).format("YYYY-MM-DD");
                    var userDailyCostMap = userWeeklyCostMap[day];
                    result['other_costs'][formattedDay] = result['other_costs'][formattedDay] || { total: 0, pay_types: {}, breakdown_per_pay_type: {} };
                    result['other_costs']['weekly'] = result['other_costs']['weekly'] || { total: 0, pay_types: {}, breakdown_per_pay_type: {} };
                    result['costs'][formattedDay] = result['costs'][formattedDay] || { total: 0, pay_types: {}, breakdown_per_pay_type: {} };
                    result['costs']['weekly'] = result['costs']['weekly'] || { total: 0, pay_types: {}, breakdown_per_pay_type: {} };
                    result['full_labor_cost'][formattedDay] = result['full_labor_cost'][formattedDay] || { total: 0, pay_types: {} };
                    result['full_labor_cost']['weekly'] = result['full_labor_cost']['weekly'] || { total: 0, pay_types: {} };

                    for (var positionCode in userDailyCostMap.positions) {

                        var userPositionCostMap = userDailyCostMap.positions[positionCode];
                        userPositionCostMap[payType] = userPositionCostMap[payType] || {cost: 0, full_cost: 0};

                        if (
                            categoriesCodes.length &&
                            userPositionCostMap.category.code !== 'NO_CATEGORY' &&
                            !categoriesCodes.includes(userPositionCostMap.category.code)
                        ) {
                            continue;
                        }

                        if (
                            positionsCodes?.length &&
                            userPositionCostMap.code !== 'NO_POSITION' &&
                            !positionsCodes.includes(userPositionCostMap.code)
                        ) {
                            continue;
                        }

                        for (var costType in userPositionCostMap) {
                            if (['SALARIED', 'WEIGHTED_SHIFT', 'HOURLY'].indexOf(costType) > -1) {

                                if (
                                    !wageAccess['ALL'] &&
                                    !wageAccess[costType] &&
                                    !isViewFullLaborAndWagePercentagesEnabled
                                ) {
                                    continue;
                                }

                                var bonus = userPositionCostMap['BONUS'] || {cost: 0, full_cost: 0};
                                var pension = userPositionCostMap['PENSION'] ||{cost: 0, full_cost: 0};
                                var ni = userPositionCostMap['NI'] || {cost: 0, full_cost: 0};
                                var additionalCost = userPositionCostMap['ADDITIONAL_COST'] || {cost: 0, full_cost: 0};
                                var overtimeCost = userPositionCostMap['OVERTIME'] || {cost: 0, full_cost: 0};
                                var splitShiftPremium = userPositionCostMap['SPLIT_SHIFT_PREMIUM'] || {cost: 0, full_cost: 0};
                                var tcgSalariedOT = userPositionCostMap['TCG_SALARIED_OT'] || {cost: 0, full_cost: 0};
                                userPositionCostMap[costType] = userPositionCostMap[costType] || {cost: 0, full_cost: 0, total: 0};

                                var holidayAccruals = 0;
                                var otherCostValue = 0;
                                var teamLiveCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
                                var appliedUKSetup = ['UK', 'DK'].indexOf(teamLiveCountryCode) > -1;
                                var addCostToTotal = isCostIncludedInTotal(costType, true);
                                var addOtherCostToTotal = isCostIncludedInTotal(costType, false);

                                if (
                                    wageAccess['ALL'] ||
                                    wageAccess[costType]
                                ) {
                                    var costValue = userPositionCostMap[costType].cost + bonus.cost + splitShiftPremium.cost;

                                    if (!['HOURLY', 'WEIGHTED_SHIFT'].includes(costType)) {
                                        costValue += overtimeCost.cost;
                                    }

                                    result['costs'][formattedDay].breakdown_per_pay_type[costType] ??= {};
                                    result['costs']['weekly'].breakdown_per_pay_type[costType] ??= {};

                                    let allUserExtraCosts = 0;
                                    const costTypeKeysPerPayType = {
                                        HOURLY: ['BONUS', 'OVERTIME', 'DOUBLE_OVERTIME', 'SPREAD_OF_HOURS', 'SPLIT_SHIFT_PREMIUM', 'DIFFERENTIAL_PAY'],
                                        SALARIED: ['BONUS', 'OVERTIME'],
                                        WEIGHTED_SHIFT: ['BONUS', 'OVERTIME'],
                                    }

                                    if (costType === "SALARIED" && isTCGCustomOTEnabled) {
                                        costValue += tcgSalariedOT.cost;
                                    }

                                    for (let key of costTypeKeysPerPayType[costType]) {
                                        if (userPositionCostMap[key]) {
                                            result['costs'][formattedDay].breakdown_per_pay_type[costType][key] ??= 0;
                                            result['costs']['weekly'].breakdown_per_pay_type[costType][key] ??= 0;
                                            result['costs'][formattedDay].breakdown_per_pay_type[costType][key] += userPositionCostMap[key].cost;
                                            result['costs']['weekly'].breakdown_per_pay_type[costType][key] += userPositionCostMap[key].cost;
                                            allUserExtraCosts += userPositionCostMap[key].cost;

                                            if (key === 'OVERTIME' && costType === "SALARIED" && isTCGCustomOTEnabled) {
                                                result['costs'][formattedDay].breakdown_per_pay_type[costType][key] += tcgSalariedOT.cost;
                                                result['costs']['weekly'].breakdown_per_pay_type[costType][key] += tcgSalariedOT.cost;
                                                allUserExtraCosts += tcgSalariedOT.cost;
                                            }
                                        }
                                    }

                                    result['costs'][formattedDay].breakdown_per_pay_type[costType][`${costType}_BASIC_COST`] ??= 0;
                                    result['costs']['weekly'].breakdown_per_pay_type[costType][`${costType}_BASIC_COST`] ??= 0;
                                    result['costs'][formattedDay].breakdown_per_pay_type[costType][`${costType}_BASIC_COST`] += (costValue - allUserExtraCosts);
                                    result['costs']['weekly'].breakdown_per_pay_type[costType][`${costType}_BASIC_COST`] += (costValue - allUserExtraCosts);

                                    result['costs'][formattedDay].pay_types[costType] = result['costs'][formattedDay].pay_types[costType] || 0;
                                    result['costs']['weekly'].pay_types[costType] = result['costs']['weekly'].pay_types[costType] || 0;

                                    result['costs'][formattedDay].pay_types[costType] += costValue;
                                    result['costs']['weekly'].pay_types[costType] += costValue;

                                    if (addCostToTotal) {
                                        result['costs'][formattedDay].total += costValue;
                                        result['costs']['weekly'].total += costValue;
                                    }
                                    result['other_costs'][formattedDay].pay_types[costType] = result['other_costs'][formattedDay].pay_types[costType] || 0;
                                    result['other_costs']['weekly'].pay_types[costType] = result['other_costs']['weekly'].pay_types[costType] || 0;
                                    result['other_costs'][formattedDay].breakdown_per_pay_type[costType] ??= {};
                                    result['other_costs']['weekly'].breakdown_per_pay_type[costType] ??= {};

                                    let otherCostTypeKeys = [];
                                    if (appliedUKSetup) {
                                        otherCostTypeKeys.push('PENSION')

                                        if (teamLiveCountryCode === 'UK') {
                                            holidayAccruals = costType === 'SALARIED' && !settings['schedule']?.add_holiday_accrual_cost_to_salaried_cost ? 0 : self.calculateHolidayAccruals(costValue);
                                            otherCostValue = pension.cost + ni.cost + holidayAccruals;
                                            otherCostTypeKeys.push('NI');
                                            otherCostTypeKeys.push('HOLIDAY_ACCRUALS');
                                        } else {
                                            otherCostValue = pension.cost;
                                        }
                                    } else {
                                        otherCostValue = additionalCost.cost;
                                        otherCostTypeKeys.push('ADDITIONAL_COST');
                                    }

                                    for (let key of otherCostTypeKeys) {
                                        let keyValue = key === 'HOLIDAY_ACCRUALS'? holidayAccruals : (userPositionCostMap[key]?.cost || 0);
                                        result['other_costs'][formattedDay].breakdown_per_pay_type[costType][key] ??= 0;
                                        result['other_costs']['weekly'].breakdown_per_pay_type[costType][key] ??= 0;
                                        result['other_costs'][formattedDay].breakdown_per_pay_type[costType][key] += keyValue;
                                        result['other_costs']['weekly'].breakdown_per_pay_type[costType][key] += keyValue;
                                    }

                                    result['other_costs'][formattedDay].pay_types[costType] += otherCostValue;
                                    result['other_costs']['weekly'].pay_types[costType] += otherCostValue;

                                    if (addOtherCostToTotal) {
                                        result['other_costs'][formattedDay].total += otherCostValue;
                                        result['other_costs']['weekly'].total += otherCostValue;
                                    }
                                }

                                    var costValue = (userPositionCostMap[costType].full_cost || 0) + bonus.full_cost + overtimeCost.full_cost + splitShiftPremium.full_cost;
                                    if (costType === "SALARIED" && isTCGCustomSalariedOTEnabled()) {
                                        costValue += tcgSalariedOT.full_cost;
                                    }
                                    result['full_labor_cost'][formattedDay].pay_types[costType] = result['full_labor_cost'][formattedDay].pay_types[costType] || 0;
                                    result['full_labor_cost']['weekly'].pay_types[costType] = result['full_labor_cost']['weekly'].pay_types[costType] || 0;

                                    result['full_labor_cost'][formattedDay].pay_types[costType] += costValue;
                                    result['full_labor_cost']['weekly'].pay_types[costType] += costValue;

                                    if (addCostToTotal) {
                                        result['full_labor_cost'][formattedDay].total += costValue;
                                        result['full_labor_cost']['weekly'].total += costValue;
                                    }

                                    if (appliedUKSetup) {
                                        if (scheduleDataServiceV2.isBrandUK) {
                                            holidayAccruals = costType === 'SALARIED' && !settings['schedule']?.add_holiday_accrual_cost_to_salaried_cost ? 0 : self.calculateHolidayAccruals(costValue);
                                            otherCostValue = pension.full_cost + ni.full_cost + holidayAccruals;
                                        } else {
                                            otherCostValue = pension.full_cost;
                                        }
                                    } else {
                                        otherCostValue = additionalCost.full_cost;
                                    }
                                    result['full_labor_cost'][formattedDay].pay_types[costType] += otherCostValue;
                                    result['full_labor_cost']['weekly'].pay_types[costType] += otherCostValue;
                                    if (addOtherCostToTotal) {
                                        result['full_labor_cost'][formattedDay].total += otherCostValue;
                                        result['full_labor_cost']['weekly'].total += otherCostValue;
                                    }
                            }
                        }
                    }
                }
            }

            defer.resolve(result);
            return defer.promise;
        };

	    var getBreakTimeWithinShift = function (shiftStart, shiftEnd, shiftDay, shiftBreak) {
            if (shiftBreak.start_time && shiftBreak.end_time) {
                var period = shiftTemplateUtils.getPeriod(shiftBreak.start_time, shiftBreak.end_time, shiftDay);
                var breakStart = period.start.getTime();
                var breakEnd = period.end.getTime();

                if (breakStart < shiftStart) {
                    breakStart = shiftStart;
                }

                if (breakEnd > shiftEnd) {
                    breakEnd = shiftEnd;
                }

                var breakDuration = (breakEnd - breakStart) / MILLISECOND;

                return breakDuration < 0 ? 0 : breakDuration;
            } else {
                return parseInt(shiftBreak["duration"]);
            }
        };

        var subtractStaticShiftBreaksSplits = function (shift) {

            if (shift && shift.breaks && shift.breaks.length) {
                var isScheduledBreaksEnabled = false;
                var totalBreaksSeconds = 0;
                var totalSplitBreaksSeconds = 0;
                var shiftBreaks = shift.breaks;
                shift.unpaidBreaks = [];

                for (var i in shiftBreaks) {

                    var breakInterval = shiftBreaks[i];

                    if (breakInterval["type"] === self.BREAKS_TYPES.UNPAID) {
                        isScheduledBreaksEnabled = !!breakInterval.start_time;
                        /**
                         * Validate if break duration is less than shift duration
                         * in case the saving of the shift did not consider validation
                         */
                        if (parseInt(breakInterval["duration"]) <= parseInt(shift.costInfo["time"])) {
                            totalBreaksSeconds += getBreakTimeWithinShift(shift.calculatedStart, shift.calculatedEnd, shift.day, breakInterval);
                        } else {
                            totalBreaksSeconds = parseInt(shift.costInfo["time"]);
                        }
                    }
                    else if (breakInterval["type"] === self.BREAKS_TYPES.SPLIT_SHIFT) {
                        totalSplitBreaksSeconds += getBreakTimeWithinShift(shift.calculatedStart, shift.calculatedEnd, shift.day, breakInterval);
                    }

                    if ([self.BREAKS_TYPES.SPLIT_SHIFT, self.BREAKS_TYPES.UNPAID].indexOf(breakInterval["type"]) > -1) {
                        shift.unpaidBreaks = shift.unpaidBreaks || [];
                        shift.unpaidBreaks.push(breakInterval);
                    }
                }

                //include only breaks time that exceeds first shift time
                if (!isScheduledBreaksEnabled && shift['isExtendedFromPreviousDay']) {
                    var parentShiftTime = shift.length - shift.costInfo.time;
                    var differenceBreaksTime = totalBreaksSeconds - parentShiftTime;
                    totalBreaksSeconds = differenceBreaksTime > 0 ? differenceBreaksTime : 0;
                }

                //add split time to total breaks time
                totalBreaksSeconds += totalSplitBreaksSeconds;

                shift.costInfo["time"] = (totalBreaksSeconds > shift.costInfo["time"]) ? 0 : (shift.costInfo["time"] - totalBreaksSeconds);
            }
        };

        var parsePreviousWeekWorkedDays = function (days) {
            var userRestDayMap = {};

            if (days && days.length) {
                var previousWeekEndDate = moment(scheduleDataServiceV2.startDate).clone().subtract(1, 'days');

                for (var i = 0; i < days.length; i++) {
                    var user = days[i];
                    userRestDayMap[user.user_id] = userRestDayMap[user.user_id] || prepareUserRestDayMap();

                    for (var j = 0; j < user.days.length; j++) {
                        var day = user.days[j];
                        var date = moment(day.date).format('MMM DD, YYYY');

                        userRestDayMap[user.user_id][date].hasWork = !!day.total_hours;
                        userRestDayMap[user.user_id][date].total_hours = day.total_hours || 0;
                    }
                    for (var scheduleDay in userRestDayMap[user.user_id]) {
                        if (userRestDayMap[user.user_id][scheduleDay].hasWork) {
                            userRestDayMap[user.user_id].worked_days_counter++;
                        }

                        if (
                            userRestDayMap[user.user_id].worked_days_counter === 7 ||
                            (!userRestDayMap[user.user_id][scheduleDay].hasWork && moment(scheduleDay).isSameOrBefore(previousWeekEndDate))
                        ) {
                            userRestDayMap[user.user_id].worked_days_counter = 0;
                        }
                    }
                }
            }

            return userRestDayMap;
        };

        var prepareUserRestDayMap = function () {
            var userRestDayMap = {worked_days_counter: 0};
            var previousStartDate = moment(scheduleDataServiceV2.startDate).clone().subtract(14, 'days');

            for (var i = 0; i < 21; i++) {
                var date = moment(previousStartDate).clone().add(i, 'days').format('MMM DD, YYYY');
                userRestDayMap[date] = {hasWork: false, total_hours: 0};
            }

            return userRestDayMap;
        };

        self.setWorkedDaysData = function (data) {
            workedDaysData = data;
        };

        self.getBreaksRulesForDay = function (day) {
            return self.breaksMap[day];
        };

        var setBreakDeservedTime = function (shiftStart, shiftEnd, breaks) {
            var updatedBreaks = []
            var shiftStartTimeInSeconds = shiftTemplateUtils.timeObjToSeconds(shiftStart).hours + shiftTemplateUtils.timeObjToSeconds(shiftStart).minutes;
            var shiftEndTimeInSeconds = shiftTemplateUtils.timeObjToSeconds(shiftEnd).hours + shiftTemplateUtils.timeObjToSeconds(shiftEnd).minutes;

            if (shiftStartTimeInSeconds < (scheduleDataServiceV2.dayOpenHour / MILLISECOND)) {
                shiftStartTimeInSeconds += DAY;
            }

            if (shiftEndTimeInSeconds < shiftStartTimeInSeconds) {
                shiftEndTimeInSeconds += DAY;

                if (shiftEndTimeInSeconds < shiftStartTimeInSeconds) {
                    shiftEndTimeInSeconds += DAY;
                }
            }

            for (var i in breaks) {
                var breakItem = angular.copy(breaks[i]);

                if (!breakItem['start_time']) {
                    var deservedStartTime = shiftStartTimeInSeconds + (breakItem['frequency'] * (breakItem['break_count'] + 1));
                    var deservedEndTime = deservedStartTime + breakItem['duration'];
                    var breakDiff = shiftEndTimeInSeconds - deservedEndTime;

                    // if the diff in -ve then we need to adjust the break time to be within the shift
                    if (breakDiff < 0) {
                        deservedEndTime = shiftEndTimeInSeconds;
                        deservedStartTime += breakDiff;
                    }

                    breakItem['end_time'] = deservedEndTime;
                    breakItem['start_time'] = deservedStartTime;
                }

                updatedBreaks.push(breakItem);
            }

            return updatedBreaks;
        };

        // this function to map the scheduled breaks with calculated breaks
        // try to find the matched breaks that have same duration and category to replace them in the deserved breaks list
        let getMappedScheduledBreaks = function (shiftBreaks, comparedBreaks) {
            let mappedBreaksList = [];
            let counter = 1;
            comparedBreaks.forEach((breakItem) => {
                const randomPart = parseInt(Math.random() * 100);
                breakItem.id = randomPart + counter * 100;
                counter++;
            });

            for (let breakItem of shiftBreaks) {
                if (breakItem.start_time && breakItem.end_time) {
                    let matchedBreaks = comparedBreaks.filter((comparedBreakItem) => {
                        if (comparedBreakItem.duration === breakItem.duration && comparedBreakItem.category === breakItem.category) {
                            return true;
                        }
                    });

                    let matchedBreakItem = matchedBreaks.find((matchedBreakItem) => {
                        if (breakItem.start_time <= matchedBreakItem.start_time) {
                            return true;
                        }
                    }) || matchedBreaks[0];

                    let matchedBreakItemIndex = comparedBreaks.findIndex((item) => {
                        return item.id === matchedBreakItem?.id;
                    });
                    if (matchedBreakItemIndex > -1) {
                        comparedBreaks.splice(matchedBreakItemIndex, 1);
                        breakItem['source'] = 'EMPLOYER';
                        mappedBreaksList.push(breakItem);
                    }
                }
            }
            return mappedBreaksList.concat(comparedBreaks);
        }

        // This function checks for overlaps between the current and previous break periods.
        // It operates under the following conditions:
        // 1. If the current break's source is from the employer, the break remains unmodified regardless of overlap.
        // 2. If the source is not from the employer and the current break overlaps with the previous break:
        //    - The function attempts to modify the current break's timing to eliminate the overlap.
        //    - If adjusting the current break would result in an overlap with the next scheduled break, no modifications are made.
        let adjustOverlappedBreaks = function (shiftTimes, breaks) {
            let shiftEndTime = shiftTimes['end_time'];
            breaks.sort((break1, break2) => break1.start_time - break2.start_time);
            for (let i = 1; i < breaks.length; i++) {
                let breakItem = breaks[i];
                let previousBreak = i > 0 ? breaks[i - 1] : null;
                let nextBreak = i < breaks.length - 1 ? breaks[i + 1] : null;

                if (breakItem.start_time >= previousBreak.start_time && breakItem.start_time <= previousBreak.end_time) {
                    if (breakItem['source'] === 'EMPLOYER') {
                        continue;
                    }
                    let overlap = previousBreak.end_time - breakItem.start_time;
                    let updatedStartTime = breakItem.start_time + overlap + HOUR;
                    let updatedEndTime = breakItem.end_time + overlap + HOUR;

                    if (
                        nextBreak &&
                        (
                            (updatedStartTime >= nextBreak.start_time && updatedStartTime <= nextBreak.end_time) ||
                            (updatedEndTime >= nextBreak.start_time && updatedEndTime <= nextBreak.end_time) ||
                            // check if next break is within the current break
                            (nextBreak.start_time >= updatedStartTime && nextBreak.end_time <= updatedEndTime) ||
                            // check if the break's start time is after the end of the shift
                            updatedStartTime >= shiftEndTime ||
                            // check if the break's end time is after the end of the shift
                            updatedEndTime >= shiftEndTime
                        )
                    ) {
                        continue;
                    }
                    breakItem.start_time = updatedStartTime;
                    breakItem.end_time = updatedEndTime;
                }
            }

        };

        var subtractDynamicUnpaidBreaks = function (shift, role_day_date) {
            if (self.breaksMap[role_day_date] && self.breaksMap[role_day_date]["values"]) {
                var intervals = [{start_time: new Date(shift.start_time), end_time: new Date(shift.end_time)}];
                var breaksObject = BreaksManagementService.calculateShiftDeservedBreaks(self.breaksMap[role_day_date], role_day_date, scheduleDataServiceV2.dayOpenHour, shift.user_id, shift.position, intervals, true);
                var unpaidBreaks = [];
                var totalBreaksTime = 0;

                if (shift.breaks && shift.breaks.length) {
                    unpaidBreaks = _.filter(shift.breaks, function (breakItem) {
                        return breakItem['type'] === self.BREAKS_TYPES.UNPAID;
                    });

                    let hasUnscheduledBreak = unpaidBreaks.filter((breakItem) => {
                        if (!breakItem.start_time || !breakItem.end_time) {
                            return true;
                        }
                    }).length > 0;

                    if (hasUnscheduledBreak) {
                        let comparedBreaks = setBreakDeservedTime(shift['start_time'], shift['end_time'], breaksObject.unpaidBreaks);
                        unpaidBreaks = getMappedScheduledBreaks(unpaidBreaks, comparedBreaks);
                        adjustOverlappedBreaks({
                            start_time: shift['start_time'],
                            end_time: shift['end_time']
                        }, unpaidBreaks);
                    }

                } else {
                    unpaidBreaks = breaksObject.unpaidBreaks;
                    shift.break_list = breaksObject.unpaidBreaks.concat(breaksObject.paidBreaks);
                }

                // for unscheduled breaks we set start/end time based on when will this break will be deserved
                unpaidBreaks = setBreakDeservedTime(shift['start_time'], shift['end_time'], unpaidBreaks);
                shift.unpaidBreaks = unpaidBreaks;

                for (var i in unpaidBreaks) {
                    var breakItem = unpaidBreaks[i];
                    totalBreaksTime += getBreakTimeWithinShift(shift.calculatedStart, shift.calculatedEnd, shift.day, breakItem);
                }

                //subtract meal breaks
                for (const breakItem of (breaksObject.unpaidBreaks ?? [])) {
                    if (breakItem.category === self.BREAK_CATEGORIES.MEAL && breakItem.payment_mode !== 'NO_PAYMENT' && !shift.isExtendedFromPreviousDay) {
                        shift.costInfo.has_meal_break_deduction = true;
                        shift.costInfo.meal_value ??= 0;
                        shift.costInfo.meal_value += breakItem['payment_value'];
                    }
                }

                shift.costInfo["time"] = (totalBreaksTime > shift.costInfo["time"]) ? 0 : (shift.costInfo["time"] - totalBreaksTime);
            }
        };

	    // check if other user shifts included in 24 hours daily period
	    var getIncludedShiftTime = function (currentShift, currentShiftEndTime, endPeriod, shift) {
            var shiftEndTime = Date.parse(shift.end_time);
            var shiftStartTime = Date.parse(shift.start_time);
            var time = 0;

            // check if other shift is within the current shift 24 hours time
            // if the shift started before current shift and end after current shift 24 hours start period
            // add shift time or part of it [depending on shift time in 24 hours period] to the current shift total 24 hours work
            //if part of 24 hours work OT, subtract it
            var isShiftIncludedIn24hoursPeriod = shift.id !== currentShift.id
                && (shiftStartTime < currentShiftEndTime)
                && (shiftEndTime > endPeriod);

            if (isShiftIncludedIn24hoursPeriod) {
                var start_period = shiftStartTime > endPeriod ? shiftStartTime : endPeriod;
                var end_period = shiftEndTime > currentShiftEndTime ? currentShiftEndTime : shiftEndTime;
                var shift_ot = (shift.costInfo && shift.costInfo.daily_overtime) || 0;
                var breakTime = 0;

                if (shift.unpaidBreaks && shift.unpaidBreaks.length) {
                    for (var b in shift.unpaidBreaks) {
                        var shiftBreak = shift.unpaidBreaks[b];
                        breakTime += getBreakTimeWithinShift(start_period, end_period, shift.day, shiftBreak);
                    }
                }

                time = Math.max(((end_period - start_period) - (shift_ot * MILLISECOND) - (breakTime * MILLISECOND)), 0);
            }

            return time;
        };

	    var getPreviousWeekShifts = function (extraScheduleDay, extraCrossDay) {
            var previousWeekShifts = [];

            for (var s in extraScheduleDay) {
                var extraScheduleDayRoles = extraScheduleDay[s].roles;

                for (var i in extraScheduleDayRoles) {
                    for (var j in extraScheduleDayRoles[i].role_days) {
                        var extraRoleDays = extraScheduleDayRoles[i].role_days[j];

                        for (var k in extraRoleDays.assignees) {
                            var assignee = extraRoleDays.assignees[k];

                            for (var l in assignee.assignee_shifts) {
                                var previousShift = assignee.assignee_shifts[l];
                                previousShift.position = extraScheduleDayRoles[i].position;
                                previousShift.costInfo = {};

                                if (activeBreaksMode === self.BREAKS_ENGINES.DYNAMIC) {
                                    subtractDynamicUnpaidBreaks(previousShift, scheduleDataServiceV2.StartDate);
                                }
                                else if (activeBreaksMode === self.BREAKS_ENGINES.STATIC) {
                                    subtractStaticShiftBreaksSplits(previousShift);
                                }

                                previousWeekShifts.push(previousShift);
                            }
                        }
                    }
                }
            }

            for (var cs in extraCrossDay) {
                var rawScheduleData = $.extend({}, extraCrossDay[cs]);

                for (var i in rawScheduleData.roles) {
                    var role = rawScheduleData.roles[i];

                    for (var j in role.role_days) {
                        var roleDay = role.role_days[j];

                        for (var k in roleDay.assignees) {
                            var assignee = roleDay.assignees[k];

                            for (var l in assignee.assignee_shifts) {
                                var previousCrossShift = assignee.assignee_shifts[l];
                                previousCrossShift.position = role.position;
                                previousCrossShift.costInfo = {};

                                if (activeBreaksMode === self.BREAKS_ENGINES.DYNAMIC) {
                                    subtractDynamicUnpaidBreaks(previousCrossShift, scheduleDataServiceV2.StartDate);
                                }
                                else if (activeBreaksMode === self.BREAKS_ENGINES.STATIC) {
                                    subtractStaticShiftBreaksSplits(previousCrossShift);
                                }

                                previousWeekShifts.push(previousCrossShift);
                            }
                        }
                    }
                }
            }

            return previousWeekShifts;
        };

	    // calculate the total work done by the user in 24 hours
        // also check the user work in other location
        // also if there are shifts included in the 24 period from day before week
	    var get24hoursWork = function (currentShift) {
	        if (currentShift.user_id) {
                var endPeriod = moment(currentShift.end_time, "MMM DD, YYYY HH:mm").subtract(1, 'days').valueOf();
                var currentShiftEndTime = Date.parse(currentShift.end_time);
                var workWithin24hours = currentShift.costInfo.time * MILLISECOND;

                var usersCrossLocationShifts = scheduleDataServiceV2.usersCrossLocationShifts && scheduleDataServiceV2.usersCrossLocationShifts[currentShift.user_id] || [];
                var userShifts = scheduleDataServiceV2.flatData['users'][currentShift.user_id] && scheduleDataServiceV2.flatData['users'][currentShift.user_id]['shift_ids'] || [];

                //calculate OT from cross location shifts
                for (var i in usersCrossLocationShifts) {
                    var crossShift = usersCrossLocationShifts[i];
                    workWithin24hours += getIncludedShiftTime(currentShift, currentShiftEndTime, endPeriod, crossShift);
                }

                //calculate OT from user shifts
                for (var i in userShifts) {
                    var shift = scheduleDataServiceV2.flatData['shifts'][userShifts[i]];
                    workWithin24hours += getIncludedShiftTime(currentShift, currentShiftEndTime, endPeriod, shift);
                }

                //check if shifts & cross shifts from day before included in calculate
                for (var i in self.previousWeekShifts) {
                    var previousShift = self.previousWeekShifts[i];

                    if (previousShift['user_id'] === currentShift['user_id']) {
                        workWithin24hours += getIncludedShiftTime(currentShift, currentShiftEndTime, endPeriod, previousShift);
                    }
                }

                return workWithin24hours / MILLISECOND;
            }
        };

        // for nevada OT rule, if the employee’s regular pay rate < 1.5x min wage (based on which min wage tier applies)
        // he gets 1.5X his regular pay for every hour worked after 8hrs in a 24 hr period.
        // else no Daily OT is applied and delete warning
	    var deserveNevadaOvertime = function (shift, role_day_date) {
	        var deserveNevadaOvertime = false;

            var userCosts = self.flatData['costs'][shift.user_id] || {};
            var position = shift['position'];

            var minimumWage = self.minimumWageMap[role_day_date];

            var hour_cost = parseFloat((userCosts
                && userCosts[position.code]
                && userCosts[position.code][role_day_date]
                && userCosts[position.code][role_day_date].rate) || 0);

            const min_wage_dollars = (minimumWage?.[0]?.value || 0) / 100;
            const min_wage_tier_2_dollars = prepareTier2WageValue(minimumWage);

            var effectiveMinimumWage = (userCosts.is_health_insurance_offeree ? min_wage_tier_2_dollars : min_wage_dollars) || 0;

            if (hour_cost < (1.5 * effectiveMinimumWage)) {
                deserveNevadaOvertime = true;
            }

            return deserveNevadaOvertime;
        };

	    var calculateShiftConsecutiveOT = function (shift) {
	    	var shift_time = shift.costInfo.time;
		    shift.costInfo.weekly_overtime += shift_time;
		    shift.costInfo['exceeded_weekly_consecutive_overtime'] = true;
		    self.userWeeklyOTHoursMap[shift.user_id] += shift.costInfo.weekly_overtime;
            var userCosts = self.flatData['costs'][shift.user_id] || {};

		    if (shift_time > (self.userConsecutiveHoursMap[shift.user_id] * HOUR)) {
			    // threshold is saved in userConsecutiveHoursMap and if > 0 subtracted from shift_time to get WDOT
			    if (self.userConsecutiveHoursMap[shift.user_id] > 0) {
				    shift.costInfo.weekly_double_overtime += shift_time - (self.userConsecutiveHoursMap[shift.user_id] * HOUR);
			    }
			    else {
				    shift.costInfo.weekly_double_overtime += shift_time;
			    }
			    shift.costInfo['exceeded_weekly_consecutive_double_overtime'] = true;
			    self.userWeeklyDoubleOTHoursMap[shift.user_id] += shift.costInfo.weekly_double_overtime;

			    // shift.costInfo.net_time -= shift.costInfo.weekly_double_overtime;
			    shift.costInfo.weekly_overtime -= shift.costInfo.weekly_double_overtime;
			    self.userWeeklyOTHoursMap[shift.user_id] -= shift.costInfo.weekly_double_overtime;
		    }

            if (shift.costInfo['exceeded_weekly_consecutive_overtime']) {
                userCosts['exceeded_weekly_consecutive_overtime'] = true;
            }

            if (shift.costInfo['exceeded_weekly_consecutive_double_overtime']) {
                userCosts['exceeded_weekly_consecutive_double_overtime'] = true;
            }

		    self.userConsecutiveHoursMap[shift.user_id] -= shift_time / HOUR;
	    };

	    var isShiftOnPrimaryLocation = function (shift) {
            var shiftDay = shift['isExtendedFromPreviousDay'] ? shift['extendedDay'] : shift['day'];

            return (
                self.flatData['costs'][shift.user_id] &&
                self.flatData['costs'][shift.user_id]["primary_brands"] &&
                self.flatData['costs'][shift.user_id]["primary_brands"][shiftDay] &&
                self.flatData['costs'][shift.user_id]["primary_brands"][shiftDay]["brand_id"] === shift.brand_id
            );
        };

        var calculateShiftTimePerCalenderDay = function (shift, nextDay, shiftNetTime, shiftOvertime) {
            var shiftStart = shift.calculatedStart;
            var shiftEnd = shift.calculatedEnd;
            var midNight = nextDay.valueOf();
            var shiftDetailsOnCalenderDay = {
                current_day: {net_time: 0, over_time: 0, duration: 0, day: shift.day},
                next_day: {net_time: 0, over_time: 0, duration: 0, day: nextDay.format("MMM DD, YYYY")}
            };

            if (shiftStart < midNight && shiftEnd <= midNight) {
                shiftDetailsOnCalenderDay['current_day']['start'] = shiftStart;
                shiftDetailsOnCalenderDay['current_day']['end'] = shiftEnd;
            } else if (shiftStart >= midNight && shiftEnd > midNight) {
                shiftDetailsOnCalenderDay['next_day']['start'] = shiftStart;
                shiftDetailsOnCalenderDay['next_day']['end'] = shiftEnd;
            } else {
                shiftDetailsOnCalenderDay['current_day']['start'] = shiftStart;
                shiftDetailsOnCalenderDay['current_day']['end'] = midNight;
                shiftDetailsOnCalenderDay['next_day']['start'] = midNight;
                shiftDetailsOnCalenderDay['next_day']['end'] = shiftEnd;
            }

            shiftDetailsOnCalenderDay['current_day']['duration'] = (
                (shiftDetailsOnCalenderDay['current_day']['end'] - shiftDetailsOnCalenderDay['current_day']['start']) / MILLISECOND
            ) || 0;

            shiftDetailsOnCalenderDay['next_day']['duration'] = (
                (shiftDetailsOnCalenderDay['next_day']['end'] - shiftDetailsOnCalenderDay['next_day']['start']) / MILLISECOND
            ) || 0;

            if (shift.unpaidBreaks && shift.unpaidBreaks.length) {
                for (var b in shift.unpaidBreaks) {
                    var shiftBreak = shift.unpaidBreaks[b];
                    var isSchedulesBreaks = !!(shiftBreak.start_time && shiftBreak.end_time);

                    if (isSchedulesBreaks) {
                        var currentDayBreakTime = 0;
                        var nextDayBreakTime = 0;

                        if (shiftDetailsOnCalenderDay['current_day']['start'] && shiftDetailsOnCalenderDay['current_day']['end']) {
                            currentDayBreakTime = getBreakTimeWithinShift(shiftDetailsOnCalenderDay['current_day']['start'], shiftDetailsOnCalenderDay['current_day']['end'], shift.day, shiftBreak);
                        }
                        if (shiftDetailsOnCalenderDay['next_day']['start'] && shiftDetailsOnCalenderDay['next_day']['end']) {
                            nextDayBreakTime = getBreakTimeWithinShift(shiftDetailsOnCalenderDay['next_day']['start'], shiftDetailsOnCalenderDay['next_day']['end'], shift.day, shiftBreak);
                        }

                        if (currentDayBreakTime > 0) {
                            shiftDetailsOnCalenderDay['current_day']['duration'] -= currentDayBreakTime;
                        }

                        if (nextDayBreakTime > 0) {
                            shiftDetailsOnCalenderDay['next_day']['duration'] -= nextDayBreakTime;
                        }

                    } else {
                        var breakDiff = shiftDetailsOnCalenderDay['next_day']['duration'] - shiftBreak["duration"];

                        if (breakDiff < 0) {
                            shiftDetailsOnCalenderDay['next_day']['duration'] = 0;
                            shiftDetailsOnCalenderDay['current_day']['duration'] += breakDiff;

                        } else {
                            shiftDetailsOnCalenderDay['next_day']['duration'] = breakDiff;
                        }
                    }
                }
            }

            var shiftTimeDiff = shiftNetTime - shiftDetailsOnCalenderDay['current_day']['duration'];
            var overTimeDiff = shiftDetailsOnCalenderDay['next_day']['duration'] - shiftOvertime;

            if (shiftTimeDiff < 0) {
                shiftDetailsOnCalenderDay['current_day']['net_time'] = shiftNetTime;
            } else {
                shiftDetailsOnCalenderDay['current_day']['net_time'] = shiftDetailsOnCalenderDay['current_day']['duration'];
                shiftDetailsOnCalenderDay['next_day']['net_time'] = shiftTimeDiff;
            }

            if (overTimeDiff < 0) {
                shiftDetailsOnCalenderDay['current_day']['over_time'] = Math.abs(overTimeDiff);
                shiftDetailsOnCalenderDay['next_day']['over_time'] = shiftDetailsOnCalenderDay['next_day']['duration'];
            } else {
                shiftDetailsOnCalenderDay['next_day']['over_time'] = shiftOvertime;
            }

            return shiftDetailsOnCalenderDay;
        };

	    var calculateShiftTimes = function (shift, role_day_date) {

	    	var brand_max_daily_seconds = self.maxDailyMap[role_day_date] && self.maxDailyMap[role_day_date]["hours"] * HOUR;
	    	var brand_double_overtime_seconds = ((self.doubleOvertimeMap[role_day_date] && self.doubleOvertimeMap[role_day_date]["hours"]) || 0) * HOUR;
	    	const user_day_seconds = self.userDailyHoursMap[shift.user_id][role_day_date]?.time;
	    	var shift_time = shift.costInfo.time;
		    var shift_overtime = 0;
		    var shift_double_overtime = 0;
		    var shift_net_time = shift_time;
            var next_day_net_time = 0;
            var next_day_overtime = 0;
		    var teamLiveCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();

		    if (['UK', 'DK'].indexOf(teamLiveCountryCode) > -1) {
                shift.costInfo.net_time = shift_net_time;
                self.userNetDailyHoursMap[shift.user_id][role_day_date] += shift.costInfo.net_time;
		        return;
            }

		    // if nevada OT settings enabled and nevada mode 24 hours get work in 24 hours not in business day
            var user_24h_seconds = (self.maxDailyMap[role_day_date] &&
                                    self.maxDailyMap[role_day_date]["type"] === "NEVADA_DAILY" &&
                                    self.maxDailyMap[role_day_date]["extraction_period_type"] === "24_HOURS" &&
                                    deserveNevadaOvertime(shift, role_day_date) &&
                                    get24hoursWork(shift)) || 0;

            var user_reference_seconds =
                (
                    self.maxDailyMap[role_day_date] &&
                    self.maxDailyMap[role_day_date]["type"] === "NEVADA_DAILY" &&
                    self.maxDailyMap[role_day_date]["extraction_period_type"] === "24_HOURS"
                ) ? user_24h_seconds : user_day_seconds;

	    	if (
	    	    brand_max_daily_seconds &&
                (user_reference_seconds > brand_max_daily_seconds) &&
                !(
                    self.maxDailyMap[role_day_date]["type"] === "NEVADA_DAILY" &&
                    self.maxDailyMap[role_day_date]["extraction_period_type"] === "BUSINESS_DAY" &&
                    !deserveNevadaOvertime(shift, role_day_date)
                )
            ) {
	    		var otDifference = user_reference_seconds - brand_max_daily_seconds;
                shift_overtime = otDifference > shift_time? shift_time: otDifference;

                shift_net_time -= shift_overtime;
		    }

            if (brand_double_overtime_seconds && user_day_seconds > brand_double_overtime_seconds) {

                var dotDifference = user_day_seconds - brand_double_overtime_seconds;
                shift_double_overtime = dotDifference > shift_time? shift_time: dotDifference;

                if (shift_overtime) {
                    shift_overtime -= shift_double_overtime;
                } else {
                	shift_net_time -= shift_double_overtime;
				}
            }

            var brand_max_weekly_seconds = self.maxWeeklyMap[role_day_date] && self.maxWeeklyMap[role_day_date]["hours"] * HOUR;
            self.userNetWeeklyHoursMap[shift.user_id] += shift_net_time;

            if (philippinesPremiumsTypes.indexOf('REGULAR_HOLIDAY') > -1 ||
                philippinesPremiumsTypes.indexOf('SPECIAL_NON_WORKING_DAY') > -1) {
                var nextDay = moment(shift.day).clone().add(1, 'days');
                var formattedNextDay = nextDay.format("MMM DD, YYYY");
                var currentDayHolidays = Object.keys(scheduleDataServiceV2.brandHolidays[shift.day] || {});
                var nextDayHolidays = Object.keys(scheduleDataServiceV2.brandHolidays[formattedNextDay] || {});
                var allHolidays = currentDayHolidays.concat(nextDayHolidays);
                var isRegularHolidayOvertimeEnabledForCurrentDay = self.isPhilippinesOverTimeSettingsEnabled('REGULAR_HOLIDAY', shift.day);
                var isRegularHolidayOvertimeEnabledForNextDay = self.isPhilippinesOverTimeSettingsEnabled('REGULAR_HOLIDAY', formattedNextDay);
                var isRegularHolidayOvertimeEnabled = isRegularHolidayOvertimeEnabledForCurrentDay || isRegularHolidayOvertimeEnabledForNextDay;
                 var isSpecialDayOvertimeEnabledForCurrentDay = self.isPhilippinesOverTimeSettingsEnabled('SPECIAL_NON_WORKING_DAY', shift.day);
                var isSpecialDayOvertimeEnabledForNextDay = self.isPhilippinesOverTimeSettingsEnabled('SPECIAL_NON_WORKING_DAY', formattedNextDay);
                var isSpecialDayOvertimeEnabled = isSpecialDayOvertimeEnabledForCurrentDay || isSpecialDayOvertimeEnabledForNextDay;

                if (
                    (isSpecialDayOvertimeEnabled && allHolidays.indexOf('SPECIAL_NON_WORKING_DAY') > -1) ||
                    (isRegularHolidayOvertimeEnabled && allHolidays.indexOf('REGULAR_HOLIDAY') > -1)
                ) {
                    var shiftDetailsOnCalenderDay = calculateShiftTimePerCalenderDay(shift, nextDay, shift_net_time, shift_overtime);
                    shift.nextDay = shiftDetailsOnCalenderDay['next_day']['day'];

                    if (shiftDetailsOnCalenderDay['current_day']['duration'] > 0) {
                        shift_net_time = shiftDetailsOnCalenderDay['current_day']['net_time'];
                        shift_overtime = shiftDetailsOnCalenderDay['current_day']['over_time'];
                    } else {
                        shift_net_time = 0;
                        shift_overtime = 0;
                    }

                    if (shiftDetailsOnCalenderDay['next_day']['duration'] > 0) {
                        next_day_net_time = shiftDetailsOnCalenderDay['next_day']['net_time'];
                        next_day_overtime = shiftDetailsOnCalenderDay['next_day']['over_time'];
                    } else {
                        next_day_net_time = 0;
                        next_day_overtime = 0;
                    }
                }
            }

            if (brand_max_weekly_seconds && self.userNetWeeklyHoursMap[shift.user_id] > brand_max_weekly_seconds) {

                var weeklyDifference = self.userNetWeeklyHoursMap[shift.user_id] - brand_max_weekly_seconds;
                var weeklyOvertime = weeklyDifference > shift_net_time? shift_net_time: weeklyDifference;

                if (self.isGuestOTEnabled) {
                    shift_net_time -= weeklyOvertime;
                    shift.costInfo['exceeded_guest_weekly_overtime'] = true;
                    shift.costInfo.guest_weekly_overtime = weeklyOvertime;
                } else {
                    if (weeklyOvertime >= shift_overtime) {
                        self.userNetWeeklyHoursMap[shift.user_id] += shift_overtime;
                        shift_net_time += shift_overtime;
                        shift_overtime += weeklyOvertime;
                        shift.costInfo.weekly_overtime += shift_overtime;
                        self.userWeeklyOTHoursMap[shift.user_id] += shift_overtime;
                        self.userNetWeeklyHoursMap[shift.user_id] -= shift_overtime;
                        shift.costInfo['exceeded_weekly_overtime'] = true;
                    } else {
                            shift.costInfo.daily_overtime += shift_overtime;
                            self.userDailyOTHoursMap[shift.user_id][role_day_date] += shift_overtime;
                            shift.costInfo['exceeded_daily_overtime'] = true;
                    }
                }

                if (shift_double_overtime) {
                    shift.costInfo.daily_double_overtime += shift_double_overtime;
                    self.userDailyDoubleOTHoursMap[shift.user_id][role_day_date] += shift_double_overtime;
                    shift.costInfo['exceeded_daily_double_overtime'] = true;
                }
            }
            else {
                if (shift_overtime) {
                    shift.costInfo.daily_overtime += shift_overtime;
                    self.userDailyOTHoursMap[shift.user_id][role_day_date] += shift_overtime;
                    shift.costInfo['exceeded_daily_overtime'] = true;
                }

                if (shift_double_overtime) {
                    shift.costInfo.daily_double_overtime += shift_double_overtime;
                    self.userDailyDoubleOTHoursMap[shift.user_id][role_day_date] += shift_double_overtime;
                    shift.costInfo['exceeded_daily_double_overtime'] = true;
                }

                if (next_day_overtime) {
                    shift.costInfo.next_day_overtime += next_day_overtime;
                    self.userDailyOTHoursMap[shift.user_id][role_day_date] += next_day_overtime;
                    shift.costInfo['exceeded_daily_overtime'] = true;
                }
			}

            if (next_day_net_time) {
                shift.costInfo.next_day_net_time = next_day_net_time;
            }

            shift.costInfo.net_time = shift_net_time;
            self.userNetDailyHoursMap[shift.user_id][role_day_date] += shift.costInfo.net_time;
            self.userDailyOTHoursMap[shift.user_id][role_day_date] += shift.costInfo.daily_overtime;
            self.userDailyDoubleOTHoursMap[shift.user_id][role_day_date] += shift.costInfo.daily_double_overtime;
	    };

	    var getMaxWeeklyHours = function () {
            return (
                self.brand_weekly_cost_settings &&
                self.brand_weekly_cost_settings["brand_max_weekly_hours"] &&
                self.brand_weekly_cost_settings["brand_max_weekly_hours"]["hours"]
            ) || 0;
        };

	    var getMaxDailyHoursForDay = function (date) {

	        return getBrandDailyCostsForDay(date) && getBrandDailyCostsForDay(date)["brand_max_daily_hours"];
	    };

	    var getBrandDailyCostsForDay = function (date) {

		    var brand_start_date = moment(self.startDate, "MMM DD, YYYY");
		    var day_date = moment(date, "MMM DD, YYYY");

		    // this is the difference between brand_start_date and the shift_start_date which is the index from the max_daily array
		    if (self.brand_daily_cost_settings) {
			    var dayDiffArrayIndex = day_date.diff(brand_start_date, 'days');
			    return self.brand_daily_cost_settings[dayDiffArrayIndex];
		    }

		    return {};
	    };

	    // Legacy, related to old SchedulerDataService
        // TODO: Check if any of these data is still in use
        // Update cost/period (hours) per different data types in scheduleDataService (role, roleDay, assignee, position)
	    self.calculatePeriods = function () {

		    self.periods = {};
		    self.perUser = {};
		    self.perPosition = {};
		    self.maxHours = 0;

		    for (var i in scheduleDataServiceV2.flatData['roles']) {
			    var role = scheduleDataServiceV2.flatData['roles'][i];
			    role.period = role.cost = role.overtime = 0;

			    self.perPosition[role.position.code] = self.perPosition[role.position.code] || {period: 0, cost: 0};

			    for (var j in role.role_days) {
				    var roleDay = role.role_days[j];
				    roleDay.period = roleDay.cost = roleDay.overtime = 0;

				    for (var m in roleDay.assignees) {
					    var assignee = roleDay.assignees[m];

					    if (!filterByUserId || assignee.user_id == filterByUserId) {
						    assignee.period = assignee.overtime = 0;
						    self.perUser[assignee.user_id] = self.perUser[assignee.user_id] || {period: 0, cost: 0};
						    var keys = ['period'];

						    if (assignee.user_id) {
							    assignee.cost = 0;
							    keys = ['period', 'cost'];
						    }

						    for (var l in assignee.assignee_shifts) {
							    var shift = assignee.assignee_shifts[l];

							    for (var k in keys) {
								    var key = keys[k];
								    role[key] = role[key] ? role[key] + shift[key] : shift[key];
								    roleDay[key] = roleDay[key] ? roleDay[key] + shift[key] : shift[key];
								    assignee[key] = assignee[key] ? assignee[key] + shift[key] : shift[key];
							    }
						    }
					    }
				    }
			    }
		    }
	    };

	    self.setActiveBreakEngine = function (breakEngines, scheduleStartDate) {

	        if (breakEngines && breakEngines.length) {
                activeBreaksMode = BreaksManagementService.getEffectiveBreakEngine(breakEngines, scheduleStartDate);
            }
            else {
                activeBreaksMode = self.BREAKS_ENGINES.NONE;
            }
        };


	    self.getActiveBreaksMode = function () {
            return activeBreaksMode;
        };

	    self.setActiveTroncMode = function (troncMode) {
            activeTroncMode = troncMode || self.TRONC_MODES.NONE;
        };

	    self.setBrandPaymentTypes = function (payTypes) {

            brandPayTypes = {};

            if (payTypes && payTypes.length) {

                for (var p in payTypes) {
                    brandPayTypes[payTypes[p]['type']] = payTypes[p];
                }
            }
            else {
                brandPayTypes[self.PAY_TYPES.HOURLY] = {type: self.PAY_TYPES.HOURLY};
            }
        };

	    self.setNICategories = function (categories, startDate) {
            const versionedNIMap = {};

            for (let i = 0; i < 7; i++) {
                const day = moment(startDate).add(i, 'days').format('MMM DD, YYYY');
                const dayCategories = getNiCategoriesForDate(categories, day) ?? [];

                for (const category of dayCategories) {
                    versionedNIMap[day] ??= {};
                    versionedNIMap[day][category.code] ??= category.ni_category_tiers ?? [];
                }
            }

            niCategoriesMap = versionedNIMap;
        };

        self.setBudgetingBudgetedHours = (budgetingHours) => {
            const laborCategories = budgetingHours.labor_categories ?? [];
            const budgetWeekDays = budgetingHours.budget_week_days ?? [];
            let allCategoriesTotal = 0;

            budgetingHoursData = {
                week: {},
                days: {},
            };

            for (let categorySales of laborCategories ?? []) {
                const value = categorySales.labor_budget.total_seconds || 0;
                budgetingHoursData.week[categorySales.category.code] = { total_seconds: value };
                allCategoriesTotal += value;
            }

            budgetingHoursData.week['ALL_CATEGORIES'] = { total_seconds: allCategoriesTotal };

            for (let budgetWeekDay of budgetWeekDays ?? []) {
                let dayTotalSeconds = 0;
                budgetingHoursData.days[budgetWeekDay.day] = {};
                for (let categorySales of budgetWeekDay.labor_categories ?? []) {
                    budgetingHoursData.days[budgetWeekDay.day][categorySales.category.code] = { total_seconds: categorySales.labor_budget.total_seconds ?? 0 };
                    dayTotalSeconds += categorySales.labor_budget.total_seconds ?? 0;
                    budgetingHoursData.week[categorySales.category.code] ??= { total_seconds: 0 };
                    budgetingHoursData.week[categorySales.category.code].total_seconds += categorySales.labor_budget.total_seconds ?? 0;
                }
                budgetingHoursData.week['ALL_CATEGORIES'] ??= { total_seconds: 0 };
                budgetingHoursData.week['ALL_CATEGORIES'].total_seconds += dayTotalSeconds;
                budgetingHoursData.days[budgetWeekDay.day]['ALL_CATEGORIES'] = { total_seconds: dayTotalSeconds };
            }
        };

	    self.getBudgetHours = function () {
	        return budgetingHoursData;
        };

	    self.setOvertimeSettings = function (otSettings, scheduleStartDate) {
            self.otEnabled = {};
            self.otType = {};

            if (otSettings) {
                var salariedOTVersions = otSettings.salaried_weekly_overtime;
                var salariedOTThisWeek;

                if (salariedOTVersions && salariedOTVersions.length) {
                    for (var i = 0; i < salariedOTVersions.length; i++) {
                        var salariedOT = salariedOTVersions[i];
                        if (moment(salariedOT.start_date).isSameOrBefore(scheduleStartDate)){
                            salariedOTThisWeek = salariedOT;
                            break;
                        }
                    }
                }

                var shiftyOTVersions = otSettings.weighted_shift_weekly_overtime;
                var shiftyOTThisWeek;

                if (shiftyOTVersions && shiftyOTVersions.length) {
                    for (var i = 0; i < shiftyOTVersions.length; i++) {
                        var shiftyOT = shiftyOTVersions[i];
                        if (moment(shiftyOT.start_date).isSameOrBefore(scheduleStartDate)){
                            shiftyOTThisWeek = shiftyOT;
                            break;
                        }
                    }
                }

                if (salariedOTThisWeek && salariedOTThisWeek.is_active) {
                    self.otEnabled[salariedOTThisWeek.pay_type] = salariedOTThisWeek.is_active;
                    self.otType[salariedOTThisWeek.pay_type] = salariedOTThisWeek.cost_unit;
                }

                if (shiftyOTThisWeek && shiftyOTThisWeek.is_active) {
                    self.otEnabled[shiftyOTThisWeek.pay_type] = shiftyOTThisWeek.is_active;
                    self.otType[shiftyOTThisWeek.pay_type] = shiftyOTThisWeek.cost_unit;
                }
            }
        };

	    self.hasWeightedShiftPayType = function () {
            return brandPayTypes &&
                (brandPayTypes.hasOwnProperty(self.PAY_TYPES.WEIGHTED_SHIFT) ||
                    (brandPayTypes.hasOwnProperty(self.PAY_TYPES.SALARIED) &&
                        brandPayTypes[self.PAY_TYPES.SALARIED]["track_mode"] === self.PAY_TYPES.WEIGHTED_SHIFT));
        };

	    self.getBrandTrackMode = function () {
            return brandPayTypes && brandPayTypes[self.PAY_TYPES.SALARIED] && brandPayTypes[self.PAY_TYPES.SALARIED]["track_mode"];
        };

        const getNiCategoriesForDate = (categories, date) => {
            const versionDate = moment(date, "MMM DD, YYYY");
            let latestNiVersion = categories?.[0];

            for (const niCategoryVersion of categories) {
                if (
                    moment(niCategoryVersion.start_date).isAfter(latestNiVersion.start_date) &&
                    versionDate.isAfter(niCategoryVersion.start_date)
                ) {
                    latestNiVersion = niCategoryVersion;
                }
            }

            return latestNiVersion?.ni_categories;
        };

	    self.setApplyBonusState = function (isBonusApplied) {
            applyBonus = isBonusApplied;
        };

        var getApplyBonusState = function () {
            return applyBonus;
        };

        self.calculateUserWeeklyBlendedRate = (userID) => {

            const userWeeklyStraightTimeCost = self.userWeeklyBlendedFinancialMap[userID]?.straight_time_cost || 0;
            const userWeeklyDifferentialPayCost = self.userWeeklyBlendedFinancialMap[userID]?.differential_pay || 0;
            const userWeeklyStationsExtraPayCost = self.userWeeklyBlendedFinancialMap[userID]?.stations_extra_pay || 0;
            const userWeeklyHoursCost = self.userWeeklyBlendedFinancialMap[userID]?.total_hours || 0;

            return (
                userWeeklyHoursCost ?
                    (
                        (userWeeklyStraightTimeCost + userWeeklyDifferentialPayCost + userWeeklyStationsExtraPayCost) / userWeeklyHoursCost
                    ) : 0
            );
        };
    };

    app.service('ScheduleCostsServiceV2', [
        'ScheduleDataServiceV2', 'TSUsersService', 'minorSchedulingService', 'breaksManagementService', 'justCauseService', 'TeamScheduleService', 'ShiftTemplateUtils', 'scheduleDateUtilsService', 'scheduleDifferentialPayService', 'workRestrictionsService','workVisasService', 'jobTitlesDataService', 'useReportingTimeWarningsFactory',
        function (ScheduleDataServiceV2, TSUsersService, minorSchedulingService, breaksManagementService, justCauseService, TeamScheduleService, ShiftTemplateUtils, scheduleDateUtilsService, ScheduleDifferentialPayService, workRestrictionsService, workVisasService, jobTitlesDataService, useReportingTimeWarningsFactory) {
	        scheduleDataServiceV2 = ScheduleDataServiceV2;
	        tsUsersService = TSUsersService;
            MinorSchedulingService = minorSchedulingService;
            WorkRestrictionsService = workRestrictionsService;
            WorkVisasService = workVisasService;
            BreaksManagementService = breaksManagementService;
            JustCauseService = justCauseService;
            scheduleDifferentialPayService = ScheduleDifferentialPayService;
            teamScheduleService = TeamScheduleService;
            shiftTemplateUtils = ShiftTemplateUtils;
            _scheduleDateUtilsService = scheduleDateUtilsService;
            _jobTitlesDataService = jobTitlesDataService;
            reportingTimeWarningsFactory = useReportingTimeWarningsFactory();

            return new ScheduleCostsServiceV2();
        }
    ]);

	ScheduleCostsServiceV2.prototype.MODES = {
		DAY: "DAY",
		WEEK: "WEEK",
		CUSTOM: "CUSTOM"
	};

	ScheduleCostsServiceV2.prototype.SPREAD_OF_HOURS_TYPES = {
		REGULAR: "REGULAR",
		MINIMUM_WAGE: "MINIMUM_WAGE",
		CUSTOM: "CUSTOM"
	};

	ScheduleCostsServiceV2.prototype.BREAKS_TYPES = {
		PAID: "PAID",
		UNPAID: "UNPAID",
        SPLIT_SHIFT: "SPLIT_SHIFT"
	};

    ScheduleCostsServiceV2.prototype.BREAKS_ENGINES = {
        STATIC: "STATIC",
        DYNAMIC: "DYNAMIC",
        NONE: "NONE"
    };

    ScheduleCostsServiceV2.prototype.TRONC_MODES = {
        POINT: "POINT",
        ANNUAL: "ANNUAL",
        NONE: "NONE"
    };

	ScheduleCostsServiceV2.prototype.SHIFT_WARNINGS = {
		DAILY_OVERTIME: "exceeded_daily_overtime",
		DAILY_DOUBLE_OVERTIME: "exceeded_daily_double_overtime",
		SPREAD_OF_HOURS: "exceeded_spread_of_hours",
		WEEKLY_OVERTIME: "exceeded_weekly_overtime",
		WEEKLY_GUEST_OVERTIME: "exceeded_guest_weekly_overtime",
		CONSECUTIVE_OVERTIME: "exceeded_weekly_consecutive_overtime",
		CONSECUTIVE_DOUBLE_OVERTIME: "exceeded_weekly_consecutive_double_overtime",
        OVER_CONTRACTED_SHIFTS: "over_contracted_shifts",
        BELOW_CONTRACTED_SHIFTS: "below_contracted_shifts",
        OVER_CONTRACTED_HOURS: "over_contracted_hours",
        BELOW_CONTRACTED_HOURS: "below_contracted_hours",
        PH_REST_DAY: 'ph_rest_day',
	};

    ScheduleCostsServiceV2.prototype.PAY_TYPES = {
        HOURLY: "HOURLY",
        WEIGHTED_SHIFT: "WEIGHTED_SHIFT",
        SALARIED: "SALARIED",
        SALARIED_HOURLY: "SALARIED_HOURLY",
        SALARIED_WEIGHTED_SHIFT: "SALARIED_WEIGHTED_SHIFT",
        NONE: null
    };

    ScheduleCostsServiceV2.prototype.BREAK_REPEAT_TYPES = {
        ONCE: "ONCE",
        FOREVER: "FOREVER"
    };

    ScheduleCostsServiceV2.prototype.BREAK_CATEGORIES = {
        ORDINARY: "ORDINARY",
        MEAL: "MEAL"
    };


    ScheduleCostsServiceV2.prototype.TCG_CUSTOME_SALARIED_OT = {
        'Relief Manager Standard': 13.41,
        'Relief Manager Premium': 16.76,
        'Manager CAT A Standard': 13.41,
        'Manager CAT A Premium': 16.76,
        'Manager CAT B Standard': 13.41,
        'Manager CAT B Premium': 16.76,
        'Junior Manager Standard': 11.97,
        'Junior Manager Premium': 14.96,
        'Junior Restaurant Manager Standard': 12.79,
        'Junior Restaurant Manager Premium': 15.99,
        'Assistant Manager CAT A Standard': 10.32,
        'Assistant Manager CAT A Premium': 12.90,
        'Assistant Manager CAT B Standard': 10.32,
        'Assistant Manager CAT B Premium': 12.90
    }



})(angular.module('harriApp'));
